import type { Translations } from './types';

export const nl: Translations = {
  // Common
  'common.loading': 'Laden…',
  'common.prev': 'Vorige',
  'common.next': 'Volgende',
  'common.cancel': 'Annuleren',
  'common.back': 'Terug',
  'common.search': 'Zoeken',
  'common.close': 'Sluiten',
  'common.exit': 'Afsluiten',
  'common.noData': 'Geen gegevens',
  'common.failedToLoad': 'Laden mislukt',
  'common.retry': 'Opnieuw proberen',
  'common.reloadPage': 'Pagina herladen',
  'common.beta': 'Bèta',

  // Auth
  'auth.subtitle': 'Kartracing-telemetrieplatform',
  'auth.signInDescription': 'Log in om toegang te krijgen tot telemetriegegevens.',
  'auth.signInWithGoogle': 'Inloggen met Google',
  'auth.signInWithApple': 'Log in met Apple',
  'auth.or': 'of',
  'auth.signingIn': 'Inloggen…',
  'auth.signOut': 'Uitloggen',

  // OAuth Consent
  'oauth.authorizeTitle': '{name} autoriseren',
  'oauth.authorizeSubtitle': '{name} wil toegang tot je kart.win-telemetrieaccount.',
  'oauth.permissionsTitle': 'Gevraagde machtigingen',
  'oauth.permSessions': 'Alle sessies, ronden en telemetriekanalen lezen',
  'oauth.permAnalysis': 'Berekende statistieken en vergelijkingen lezen',
  'oauth.permSetups': 'Kart-setups en circuitconfiguraties lezen',
  'oauth.signedIn': 'Ingelogd',
  'oauth.mustSignInFirst': 'Log in om deze applicatie te autoriseren',
  'oauth.authorizeButton': 'Applicatie autoriseren',
  'oauth.missingParams': 'Vereiste OAuth-autorisatieparameters ontbreken',

  // Settings
  'settings.title': 'Instellingen',
  'settings.account': 'Account',
  'settings.profile': 'Profiel',
  'settings.displayName': 'Weergavenaam',
  'settings.saveName': 'Naam opslaan',
  'settings.nameSaved': 'Naam succesvol bijgewerkt',
  'settings.linkedAccounts': 'Gekoppelde accounts',
  'settings.linkGoogle': 'Google-account koppelen',
  'settings.linkApple': 'Apple-account koppelen',
  'settings.unlink': 'Ontkoppelen',
  'settings.linked': 'Gekoppeld',
  'settings.notLinked': 'Niet gekoppeld',
  'settings.cannotUnlinkOnlyProvider': 'Er moet ten minste één inlogmethode gekoppeld blijven.',
  'settings.language': 'Taal',
  'settings.userId': 'Gebruikers-ID',
  'settings.signOut': 'Uitloggen',
  'settings.connectedApps': 'Gekoppelde applicaties',
  'settings.connectedAppsDesc': 'Beheer AI-assistenten, IDE\'s en tools die geautoriseerd zijn om via MCP toegang te krijgen tot je telemetriegegevens.',
  'settings.noConnectedApps': 'Nog geen gekoppelde applicaties. Autoriseer een MCP-client (zoals Claude Desktop of Cursor) om deze hier te zien.',
  'settings.authorizedOn': 'Geautoriseerd',
  'settings.lastUsed': 'Laatst gebruikt',
  'settings.neverUsed': 'Nooit',
  'settings.revoke': 'Intrekken',
  'settings.revokeAppConfirm': 'Weet je zeker dat je de toegang voor deze applicatie wilt intrekken? Actieve sessies stoppen direct met werken.',
  'settings.appRevokedSuccess': 'Applicatietoegang succesvol ingetrokken',
  'settings.copyKey': 'Snippet kopiëren',
  'settings.keyCopied': 'Gekopieerd naar klembord',
  'settings.mcpConfigSnippet': 'MCP-clientconfiguratie',
  'settings.mcpConfigDesc': 'Voeg deze configuratie toe aan je Claude Desktop (claude_desktop_config.json) of Cursor MCP-instellingen. Authenticatie verloopt automatisch via je browser:',
  'settings.deleteAccount': 'Account verwijderen',
  'settings.deleteAccountDesc': 'Verwijder je account en alle bijbehorende sessies, telemetriegegevens, opgeslagen analyses, materiaal, kart-setups en gedeelde items definitief.',
  'settings.deleteAccountConfirmTitle': 'Account definitief verwijderen?',
  'settings.deleteAccountConfirmDesc': 'Deze actie kan niet ongedaan worden gemaakt. Al je eigen sessies, telemetriegegevens, opgeslagen analyses, materiaal, kart-setups, teams en gedeelde sessies worden direct en definitief verwijderd.',
  'settings.deleteAccountConfirmPrompt': 'Typ ter bevestiging "{phrase}" in het veld hieronder:',
  'settings.deleteAccountConfirmPhrase': 'mijn account verwijderen',
  'settings.deleteAccountConfirmButton': 'Mijn account verwijderen',

  // Dashboard
  'dashboard.overview': 'Overzicht',
  'dashboard.subtitle': 'Telemetrie- & rondegegevens',
  'dashboard.recentSessions': 'Recente sessies',
  'dashboard.total': '{n} totaal',
  'dashboard.failedToLoadDashboard': 'Dashboard laden mislukt',
  'dashboard.noDataAvailable': 'Geen gegevens beschikbaar',

  // Stats
  'stats.sessions': 'Sessies',
  'stats.laps': 'Ronden',
  'stats.trackTime': 'Baantijd',
  'stats.tracks': 'Circuits',

  // Search
  'search.placeholder': 'Zoek sessies… (bijv. name:WOHLEN laps:>=5)',
  'search.button': 'Zoeken',
  'search.syntaxHelp': 'Hulp bij zoeksyntax',
  'search.title': 'Zoekopdracht-syntax',
  'search.subtitle': 'Filter sessies met veld:waarde-paren. Meerdere termen worden gecombineerd met EN.',
  'search.closeDialog': 'Venster sluiten',
  'search.operatorsTitle': 'Operatoren & logica',
  'search.examplesTitle': 'Voorbeeldzoekopdrachten',
  'search.numericComparisons': 'Numerieke vergelijkingen:',
  'search.range': 'Bereik:',
  'search.rangeDesc': '— komt overeen met waarden tussen 5 en 20 (inclusief).',
  'search.booleanLogic': 'Booleaanse logica:',
  'search.booleanLogicDesc': 'Termen worden impliciet gecombineerd met',
  'search.quotes': 'Aanhalingstekens:',
  'search.quotesDesc': 'Zet waarden met spaties tussen dubbele aanhalingstekens, bijv.',

  // Filter UI
  'filter.add': 'Filter toevoegen',
  'filter.allActive': 'Alle filters actief',
  'filter.clearAll': 'Alles wissen',
  'filter.clear': 'Wissen',
  'filter.apply': 'Toepassen',
  'filter.cancel': 'Annuleren',
  'filter.condition': 'Voorwaarde',
  'filter.presets': 'Voorinstellingen',
  'filter.customRange': 'Aangepast bereik',
  'filter.from': 'Van',
  'filter.to': 'Tot',
  'filter.min': 'Min',
  'filter.max': 'Max',
  'filter.value': 'Waarde',
  'filter.searchOptions': 'Opties zoeken...',
  'filter.noOptions': 'Geen opties gevonden',
  'filter.loadingOptions': 'Opties laden...',

  // Search fields
  'search.field.bareText': '(vrije tekst)',
  'search.field.bareTextDesc': 'Komt overeen met circuitnaam of rijdersnaam die de tekst bevat.',
  'search.field.name': 'name',
  'search.field.nameDesc': 'Komt overeen met circuitnaam of rijdersnaam die de waarde bevat.',
  'search.field.driver': 'driver',
  'search.field.driverDesc': 'Komt overeen met rijdersnaam die de waarde bevat.',
  'search.field.laps': 'laps',
  'search.field.lapsDesc': 'Filter op aantal voltooide ronden. Ondersteunt =, >, >=, <, <= en bereiken.',
  'search.field.temp': 'temp',
  'search.field.tempDesc': 'Filter op buitentemperatuur (°C). Ondersteunt vergelijkingsoperatoren en bereiken.',
  'search.field.season': 'season',
  'search.field.seasonDesc': 'Filter op seizoensjaar (afgeleid van sessiedatum). Ondersteunt vergelijkingsoperatoren.',
  'search.field.from': 'from',
  'search.field.fromDesc': 'Sessies op of na een datum. Accepteert JJJJ-MM-DD of relatief: -7d, -2w, -3m, -1y.',
  'search.field.to': 'to',
  'search.field.toDesc': 'Sessies op of vóór een datum. Zelfde formaten als "from".',

  // Search examples
  'search.example.wohlenLaps': 'Sessies op Wohlen met 5+ ronden',
  'search.example.yanick30d': 'Sessies van Yanick van de afgelopen 30 dagen',
  'search.example.tempLaps': 'Sessies tussen 15–25 °C met 3+ ronden',
  'search.example.wohlenMagny': 'Sessies op Wohlen of Magny van het afgelopen jaar',

  // Session list
  'sessionList.date': 'Datum',
  'sessionList.time': 'Tijd',
  'sessionList.track': 'Circuit',
  'sessionList.sessions': 'Sessies',
  'sessionList.driver': 'Rijder',
  'sessionList.laps': 'Ronden',
  'sessionList.best': 'Beste',
  'sessionList.weather': 'Weer',
  'sessionList.lapsUnit': '{n} ronden',
  'sessionList.sessionCount': '{count} sessies',
  'sessionList.sessionCountSingular': '1 sessie',
  'sessionList.noSessions': 'Geen sessies gevonden. Probeer een andere zoekopdracht.',

  // Track bests
  'trackBests.title': 'Baanrecords',

  // Session detail
  'session.title': 'Sessie',
  'session.failedToLoad': 'Sessie laden mislukt',
  'session.noData': 'Geen sessiegegevens',
  'session.chipOverview': 'Overzicht',
  'session.chipDiff': 'Verschil',
  'session.tabWeather': 'Weer',
  'session.tabLaps': 'Ronden',
  'session.tabSetup': 'Setup',
  'session.tabManage': 'Beheren',
  'session.dangerZone': 'Gevarenzone',
  'session.deleteDescription': 'Verwijder deze sessie, alle geregistreerde ronden en telemetriegegevens definitief. Deze actie kan niet ongedaan worden gemaakt.',
  'session.delete': 'Sessie verwijderen',
  'session.deleteConfirmTitle': 'Sessie verwijderen',
  'session.deleteConfirmMessage': 'Weet je zeker dat je deze sessie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt en verwijdert alle ronde- en telemetriegegevens definitief.',
  'session.deleteSuccess': 'Sessie succesvol verwijderd',
  'session.deleteFailed': 'Sessie verwijderen mislukt',
  'session.deleting': 'Sessie verwijderen...',

  // Session meta
  'sessionMeta.date': 'Datum',
  'sessionMeta.driver': 'Rijder',
  'sessionMeta.track': 'Circuit',
  'sessionMeta.laps': 'Ronden',
  'sessionMeta.device': 'Apparaat',
  'sessionMeta.status': 'Status',
  'sessionMeta.tyres': 'Banden',
  'sessionMeta.tyreAge': '{n} ronden',
  'sessionMeta.fresh': 'Nieuw',

  // Weather
  'weather.wind': 'Wind',
  'weather.humidity': 'Luchtvochtigheid',
  'weather.cloudCover': 'Bewolking',
  'weather.precipitation': 'Neerslag',
  'weather.pressure': 'Luchtdruk',
  'weather.feels': 'Gevoelstemp.',
  'weather.clear': 'Helder',
  'weather.partlyCloudy': 'Halfbewolkt',
  'weather.overcast': 'Bewolkt',
  'weather.fog': 'Mist',
  'weather.drizzle': 'Motregen',
  'weather.rain': 'Regen',
  'weather.freezingRain': 'IJzel',
  'weather.snow': 'Sneeuw',
  'weather.rainShowers': 'Regenbuien',
  'weather.snowShowers': 'Sneeuwbuien',
  'weather.thunderstorm': 'Onweer',
  'weather.unknown': 'Onbekend',

  // Lap table
  'lapTable.title': 'Rondetijden',
  'lapTable.theoLap': 'Snelste ronde',
  'lapTable.aggregation': 'Aggregatie',
  'lapTable.compare': 'Vergelijken',
  'lapTable.lapTime': 'Rondetijd',
  'lapTable.delta': 'Delta',
  'lapTable.maxRpm': 'Max. RPM',
  'lapTable.minRpm': 'Min. RPM',
  'lapTable.maxSpeed': 'Max. snelheid',
  'lapTable.minSpeed': 'Min. snelheid',
  'lapTable.tyreAge': 'Bandenleeftijd',

  // Diff chart
  'diffChart.outlierLap': 'Niet relevant',
  'diffChart.deltaToBest': 'Delta t.o.v. beste',

  // Lap analysis
  'lapAnalysis.title': 'Ronde {n} analyse',
  'lapAnalysis.resetZoom': 'Zoom herstellen',
  'lapAnalysis.speed': 'Snelheid',
  'lapAnalysis.acceleration': 'Acceleratie',
  'lapAnalysis.rpm': 'RPM',
  'lapAnalysis.gForce': 'G-kracht',
  'lapAnalysis.trackMap': 'Circuitkaart',
  'lapAnalysis.failedToLoad': 'Telemetrie laden mislukt',
  'lapAnalysis.noTelemetry': 'Geen telemetriegegevens voor deze ronde.',

  // Lap info
  'lapInfo.lapTime': 'Rondetijd',
  'lapInfo.maxRpm': 'Max. RPM',
  'lapInfo.minRpm': 'Min. RPM',
  'lapInfo.maxSpeed': 'Max. snelheid',
  'lapInfo.maxTemp': 'Max. temp.',
  'lapInfo.gpsOffset': 'GPS-offset',
  'lapInfo.gpsOffsetTooltip': 'Gecorrigeerde GPS-drift: {east} O, {north} N',

  // Navigation
  'nav.data': 'Gegevens',
  'nav.home': 'Sessies',
  'nav.tools': 'Tools',
  'nav.compare': 'Vergelijken',
  'nav.drivers': 'Rijders',
  'nav.tracks': 'Circuits',
  'nav.settings': 'Instellingen',

  // Analysis
  'analysis.title': 'Analysetools',
  'analysis.subtitle': 'Duik diep in je telemetriegegevens met gespecialiseerde analysetools.',
  'analysis.sector.title': 'Sectoranalyse',
  'analysis.sector.desc': 'Vergelijk rondesectoren over meerdere sessies om theoretische topronden te vinden en consistentie te analyseren.',

  // Braking Analysis
  'analysis.braking.title': 'Remanalyse',
  'analysis.braking.desc': 'Analyseer rempunten, vertragingszones, G-G-wrijvingscirkels en trailbraking-efficiëntie.',
  'braking.title': 'Remanalyse',
  'braking.desc': 'Analyseer rempunten, vertragingszones, G-G-wrijvingscirkels en trailbraking-efficiëntie.',
  'braking.wizardChooseTrack': 'Kies circuit',
  'braking.wizardSelect': 'Selecteer sessies',
  'braking.wizardResults': 'Resultaten',
  'braking.noTracksWithCorners': 'Geen circuits met geconfigureerde circuitvorm en bochten beschikbaar.',
  'braking.noSessionsForTrack': 'Geen sessies gevonden voor circuit',
  'braking.noBrakingZones': 'Geen remzones gedetecteerd voor dit circuit.',
  'braking.selectZone': 'Selecteer remzone',
  'braking.zone': 'Remzone',
  'braking.zones': 'Remzones',
  'braking.brakePoint': 'Rempunt',
  'braking.apex': 'Apex',
  'braking.exit': 'Uitgang',
  'braking.distance': 'Remafstand',
  'braking.duration': 'Remduur',
  'braking.initialSpeed': 'Aanvangssnelheid',
  'braking.apexSpeed': 'Min. snelheid',
  'braking.minSpeed': 'Min. snelheid',
  'braking.brakeRelease': 'Rem loslaten',
  'braking.exitSpeed': 'Uitsnelheid',
  'braking.speedDrop': 'Snelheidsafname',
  'braking.peakDecel': 'Piekvertraging',
  'braking.peakLateral': 'Pieklaterale grip',
  'braking.trailScore': 'Trailbraking-score',
  'braking.trailScoreDesc': 'Maatstaf voor benutting van de wrijvingscirkel tijdens de overgang van rechtuit remmen naar lateraal insturen.',
  'braking.scoreOptimal': 'Optimaal',
  'braking.scoreGood': 'Goed',
  'braking.scoreNeedsWork': 'Aandachtspunt',
  'braking.sessionMedian': 'Sessiemediaan',
  'braking.selectedLap': 'Geselecteerde ronde',
  'braking.speedTransition': 'Snelheidsovergang',
  'braking.decelAndGrip': 'Vertraging & grip',
  'braking.trailScoreAdviceOptimal': 'Uitstekend gedoseerd loslaten van de rem bij het insturen. Hoge benutting van de wrijvingscirkel.',
  'braking.trailScoreAdviceGood': 'Vloeiende overgang. Mogelijkheid om iets dieper de bocht in te trailbraken.',
  'braking.trailScoreAdviceNeedsWork': 'Abrupt loslaten van de rem vóór het insturen. Focus op het geleidelijk loslaten van de rem tijdens het insturen.',
  'braking.overallHeader': 'Algemene remprestaties',
  'braking.overallHeaderDesc': 'Trailbraking-efficiëntie over het hele circuit en bochtconsistentie over alle geselecteerde ronden en sessies.',
  'braking.perCornerHeader': 'Analyse per bocht',
  'braking.perCornerHeaderDesc': 'Gedetailleerde kinematica, G-G-wrijvingscirkel en telemetrielijnen voor de geselecteerde remzone.',
  'braking.overallScore': 'Totale trailbraking-score',
  'braking.overallScoreDesc': 'Gemiddelde benutting van de wrijvingscirkel over alle bochten en ronden',
  'braking.mostConsistentCorner': 'Meest consistente bocht',
  'braking.leastConsistentCorner': 'Minst consistente bocht',
  'braking.consistency': 'Consistentie',
  'braking.lapTimeline': 'Score-tijdlijn per ronde',
  'braking.sessionComparison': 'Sessievergelijking',
  'braking.selectCornerHint': 'Klik om bocht te inspecteren',
  'braking.stdDevLabel': 'Std.afw.',
  'braking.ggDiagram': 'G-G-diagram',
  'braking.frictionCircle': 'Wrijvingscirkel',
  'braking.telemetryChart': 'Remtelemetrie',
  'braking.speed': 'Snelheid',
  'braking.gLong': 'Longitudinale G',
  'braking.gLat': 'Laterale G',
  'braking.gTotal': 'Gecombineerde G',
  'braking.allLaps': 'ronden',
  'braking.compareLap': 'Vergelijken',
  'braking.comparisonLap': 'Vergelijking',
  'braking.clearComparison': 'Vergelijking wissen',
  'braking.lapTime': 'Rondetijd',
  'braking.driver': 'Rijder',
  'braking.lap': 'Ronde',
  'braking.lapSpeedTable': 'Overzicht remronden',
  'braking.lapsAnalyzed': 'ronden geanalyseerd',
  'braking.legendDecel': 'Rechtuit remmen',
  'braking.legendTrail': 'Trailbraking',
  'braking.legendApex': 'Apex',
  'braking.legendExit': 'Gas bij uitkomen',

  // Corner Speed Analysis
  'analysis.corner.title': 'Bochtsnelheidsanalyse',
  'analysis.corner.desc': 'Meet en vergelijk ingangs-, apex- en uitsnelheden van bochten over verschillende ronden en sessies.',
  'corner.title': 'Bochtsnelheidsanalyse',
  'corner.wizardChooseTrack': 'Kies circuit',
  'corner.wizardSelect': 'Selecteer sessies',
  'corner.wizardResults': 'Resultaten',
  'corner.entrance': 'Ingang',
  'corner.apex': 'Apex',
  'corner.exit': 'Uitgang',
  'corner.entranceSpeed': 'Ingangssnelheid',
  'corner.apexSpeed': 'Apexsnelheid',
  'corner.exitSpeed': 'Uitsnelheid',
  'corner.speedGain': 'Snelheidswinst',
  'corner.turn': 'Bocht',
  'corner.leftTurn': 'Bocht naar links',
  'corner.rightTurn': 'Bocht naar rechts',
  'corner.avgSpeed': 'Gemiddelde snelheid',
  'corner.maxSpeed': 'Max. snelheid',
  'corner.minSpeed': 'Min. snelheid',
  'corner.fastest': 'Snelste',
  'corner.slowest': 'Langzaamste',
  'corner.spread': 'Spreiding',
  'corner.deltaToBest': 'Δ t.o.v. beste',
  'corner.deltaToAvg': 'Δ t.o.v. gem.',
  'corner.allCornersOverview': 'Overzicht alle bochten',
  'corner.aggregatedData': 'Geaggregeerde snelheidsstatistieken',
  'corner.lapSpeedTable': 'Bochtsnelheden per ronde',
  'corner.lapsAnalyzed': 'ronden geanalyseerd',
  'corner.noTracksWithCorners': 'Geen circuits met geconfigureerde circuitvorm en bochten beschikbaar.',
  'corner.noSessionsForTrack': 'Geen sessies gevonden voor circuit',
  'corner.noCornersFound': 'Geen bochtannotaties gevonden voor dit circuit.',
  'corner.selectCorner': 'Selecteer bocht',
  'corner.rank': 'Pos.',
  'corner.driver': 'Rijder',
  'corner.lap': 'Ronde',
  'corner.lapTime': 'Rondetijd',
  'corner.session': 'Sessie',
  'corner.speed': 'Snelheid',
  'corner.avgMax': 'Gem. / Max.',
  'corner.activeMetric': 'Actieve metriek:',
  'corner.metricSpeed': 'Snelheid',
  'corner.metricRpm': 'RPM',
  'corner.metricDuration': 'Duur',
  'corner.entranceRpm': 'Ingangs-RPM',
  'corner.apexRpm': 'Apex-RPM',
  'corner.exitRpm': 'Uitgangs-RPM',
  'corner.rpmGain': 'RPM-winst',
  'corner.rpm': 'RPM',
  'corner.duration': 'Duur',
  'corner.transitDuration': 'Doorlooptijd bocht',
  'corner.bestDuration': 'Beste duur',
  'corner.avgDuration': 'Gem. duur',
  'corner.worstDuration': 'Langzaamste duur',
  'corner.deltaToBestDuration': 'Δ t.o.v. beste',
  'corner.fullTransit': 'Volledige doorgang',

  // Sector analysis
  'sector.wizardChooseTrack': 'Kies circuit',
  'sector.wizardDefine': 'Definieer sectoren',
  'sector.wizardSelect': 'Selecteer sessies',
  'sector.wizardResults': 'Resultaten',
  'sector.title': 'Sectoranalyse',
  'sector.defineSectors': 'Definieer sectoren',
  'sector.clickToAdd': 'Klik om toe te voegen · Sleep om te verplaatsen (max. 3 sectoren)',
  'sector.selectSessions': 'Selecteer sessies →',
  'sector.analyzingLap': '⏳ Ronde analyseren…',
  'sector.analyzeLap': '⚡ Analyseer ronde',
  'sector.noResults': 'Geen resultaten beschikbaar',
  'sector.noResultsHint': 'Ga terug en pas je sectoren of sessies aan',
  'sector.trackSectors': 'Circuitsectoren',
  'sector.sectorN': 'Sector {n}',
  'sector.noSessionsForTrack': 'Geen sessies gevonden voor circuit',
  'sector.failedToLoad': 'Laden van sectoranalyse mislukt',
  'sector.lapStats': 'Rondestatistieken',
  'sector.lapStatsDriver': 'Rijder',
  'sector.lapStatsTotal': 'Totaal',

  // Sector panel
  'sectorPanel.time': 'Tijd',
  'sectorPanel.topSpeed': 'Topsnelheid',
  'sectorPanel.minSpeed': 'Min. snelheid',
  'sectorPanel.maxRpm': 'Max. RPM',
  'sectorPanel.minRpm': 'Min. RPM',
  'sectorPanel.duration': 'Duur',
  'sectorPanel.best': 'Beste',
  'sectorPanel.avg': 'Gem.',
  'sectorPanel.median': 'Mediaan',
  'sectorPanel.worst': 'Slechtste',
  'sectorPanel.p10': 'P10',
  'sectorPanel.p5': 'P5',
  'sectorPanel.consistency': 'Consistentie',
  'sectorPanel.lapByLap': 'Tijdlijn per ronde',
  'sectorPanel.sessionMedians': 'Sessiemedianen',
  'sectorPanel.medianTopSpeed': 'Mediaan topsnelheid',
  'sectorPanel.medianMinSpeed': 'Mediaan min. snelheid',
  'sectorPanel.medianMaxRpm': 'Mediaan max. RPM',
  'sectorPanel.medianMinRpm': 'Mediaan min. RPM',
  'sectorPanel.medianTime': 'Mediaan tijd',
  'sectorPanel.session': 'Sessie',
  'sectorPanel.lap': 'Ronde',
  'sectorPanel.maxSpeed': 'Max. snelheid',

  // Split points
  'splitPoints.clearAll': 'Alles wissen',

  // Session selector
  'sessionSelector.allDrivers': 'Alle rijders',
  'sessionSelector.allWeather': 'Alle weersomstandigheden',
  'sessionSelector.dryOnly': '☀️ Alleen droog',
  'sessionSelector.wetOnly': '🌧️ Alleen nat',
  'sessionSelector.selectAll': 'Alles selecteren',
  'sessionSelector.deselectAll': 'Alles deselecteren',

  // Theoretical best
  'theoBest.title': 'Theoretisch beste ronde',
  'theoBest.type': 'Type',
  'theoBest.time': 'Tijd',
  'theoBest.delta': 'Delta',
  'theoBest.theoretical': 'Theoretisch',
  'theoBest.actualBest': 'Werkelijk beste',

  // Lap selector
  'lapSelector.title': 'Selecteer ronden',
  'lapSelector.loadingLaps': 'Ronden laden…',
  'lapSelector.noLaps': 'Geen ronden',
  'lapSelector.best': 'BESTE',

  // Navigation – races
  'nav.races': 'Races',

  // Tracks
  'tracks.title': 'Circuits',
  'tracks.subtitle': 'Alle circuits & klassementen',
  'tracks.noData': 'Geen circuits beschikbaar',
  'tracks.failedToLoad': 'Circuits laden mislukt',
  'tracks.sessions': '{n} sessies',
  'tracks.raceSessions': '{n} racesessies',
  'tracks.bestLap': 'Beste ronde',
  'tracks.rank': '#',
  'tracks.lapTime': 'Rondetijd',
  'tracks.driver': 'Rijder',
  'tracks.date': 'Datum',
  'tracks.sectors': 'Sectoren',
  'tracks.weather': 'Weer',
  'tracks.measuredLapsTab': 'Gemeten ronden',
  'tracks.raceTab': 'Races',
  'tracks.leaderboard': 'Klassement',
  'tracks.category': 'Categorie',
  'tracks.season': 'Seizoen',
  'tracks.position': 'Pos.',
  'tracks.sessionType': 'Type',
  'tracks.sourceCanonical': 'Circuit',
  'tracks.sourceSession': 'Alleen sessie',
  'tracks.sourceRaceEvent': 'Alleen race',
  'tracks.searchPlaceholder': 'Zoek circuits…',
  'tracks.source': 'Bron',
  'tracks.searchHelp.title': 'Zoeksyntax voor circuits',
  'tracks.searchHelp.subtitle': 'Zoek op circuitnaam. Hoofdletters en accenttekens worden genegeerd.',
  'tracks.searchHelp.nameField': '(tekst)',
  'tracks.searchHelp.nameDesc': 'Komt overeen met circuits waarvan de naam de opgegeven tekst bevat. Letters met accenten worden herkend ongeacht accenttekens (bijv. "Geneve" vindt "Genève").',
  'tracks.searchHelp.example1': 'Wohlen',
  'tracks.searchHelp.example1Desc': 'Alle circuits met "Wohlen"',
  'tracks.searchHelp.example2': 'franciacorta',
  'tracks.searchHelp.example2Desc': 'Hoofdletterongevoelige zoekopdracht voor "Franciacorta"',
  'tracks.searchHelp.example3': 'Sarno',
  'tracks.searchHelp.example3Desc': 'Alle circuits met "Sarno"',

  // Track detail tabs
  'tracks.layoutTab': 'Lay-out',
  'tracks.noTrackLayout': 'Geen circuitlay-out beschikbaar',
  'tracks.officialLapsTab': 'Officiële ronden',
  'tracks.noRaceEvents': 'Geen race-evenementen gevonden',
  'tracks.round': 'Ronde',
  'tracks.championship': 'Kampioenschap',
  'tracks.dateStart': 'Datum',
  'tracks.country': 'Land',
  'tracks.sessionsCount': 'Sessies',
  'tracks.driversCount': 'Rijders',
  // Track race events search
  'tracks.raceEvents.searchPlaceholder': 'Zoek race-evenementen…',
  'tracks.raceEvents.searchHelp.title': 'Race-evenementen zoeken',
  'tracks.raceEvents.searchHelp.subtitle': 'Filter race-evenementen op seizoen of kampioenschapsnaam',
  'tracks.raceEvents.searchHelp.seasonField': 'season:<jaar>',
  'tracks.raceEvents.searchHelp.seasonDesc': 'Filter op seizoensjaar (exacte overeenkomst)',
  'tracks.raceEvents.searchHelp.championshipField': 'championship:<naam>',
  'tracks.raceEvents.searchHelp.championshipDesc': 'Filter op kampioenschapsnaam (hoofdletterongevoelig)',
  'tracks.raceEvents.searchHelp.example1': 'season:2026',
  'tracks.raceEvents.searchHelp.example1Desc': 'Alle evenementen uit het seizoen 2026',
  'tracks.raceEvents.searchHelp.example2': 'championship:RMC',
  'tracks.raceEvents.searchHelp.example2Desc': 'Alle evenementen van kampioenschappen met "RMC"',

  // Track leaderboard search
  'tracks.leaderboard.searchPlaceholder': 'Zoek ronden...',
  'tracks.leaderboard.searchHelp.title': 'Klassement zoeken',
  'tracks.leaderboard.searchHelp.subtitle': 'Gebruik filters om de resultaten te verfijnen',
  'tracks.leaderboard.searchHelp.driverField': 'driver:<naam>',
  'tracks.leaderboard.searchHelp.driverDesc': 'Filter op rijdersnaam (hoofdletterongevoelig)',
  'tracks.leaderboard.searchHelp.seasonField': 'season:<jaar>',
  'tracks.leaderboard.searchHelp.seasonDesc': 'Filter op seizoensjaar',
  'tracks.leaderboard.searchHelp.categoryField': 'category:<naam>',
  'tracks.leaderboard.searchHelp.categoryDesc': 'Filter op categorie (bijv. DD2, Junior)',
  'tracks.leaderboard.searchHelp.typeField': 'type:<sessieType>',
  'tracks.leaderboard.searchHelp.typeDesc': 'Filter op racetype (qualifying, heat-1, final...)',
  'tracks.leaderboard.searchHelp.posField': 'pos<:<N>',
  'tracks.leaderboard.searchHelp.posDesc': 'Maximale eindpositie (bijv. pos<:3 = podium)',
  'tracks.leaderboard.searchHelp.tempMinField': 'temp>:<N>',
  'tracks.leaderboard.searchHelp.tempMinDesc': 'Minimumtemperatuur in °C',
  'tracks.leaderboard.searchHelp.tempMaxField': 'temp<:<N>',
  'tracks.leaderboard.searchHelp.tempMaxDesc': 'Maximumtemperatuur in °C',
  'tracks.leaderboard.searchHelp.fromField': 'from:<JJJJ-MM-DD>',
  'tracks.leaderboard.searchHelp.fromDesc': 'Filter op startdatum',
  'tracks.leaderboard.searchHelp.toField': 'to:<JJJJ-MM-DD>',
  'tracks.leaderboard.searchHelp.toDesc': 'Filter op einddatum',
  'tracks.leaderboard.searchHelp.example1': 'driver:gubser season:2026',
  'tracks.leaderboard.searchHelp.example1Desc': 'Zoek een rijder in het seizoen 2026',
  'tracks.leaderboard.searchHelp.example2': 'category:dd2 type:final',
  'tracks.leaderboard.searchHelp.example2Desc': 'Alleen DD2-finales',
  'tracks.leaderboard.searchHelp.example3': 'pos<:3 from:2026-01-01',
  'tracks.leaderboard.searchHelp.example3Desc': 'Podiumplaatsen in 2026',

  // Drivers
  'drivers.title': 'Rijders',
  'drivers.driver': 'Rijder',
  'drivers.events': 'Evenementen',
  'drivers.noData': 'Geen rijders gevonden',
  'drivers.failedToLoad': 'Rijders laden mislukt',
  'drivers.searchPlaceholder': 'Zoek op naam…',

  // Races
  'races.title': 'Raceresultaten',
  'races.seasons': 'Seizoenen',
  'races.events': '{n} evenementen',
  'races.categories': '{n} categorieën',
  'races.round': 'Ronde {n}',
  'races.allCategories': 'Alle categorieën',
  'races.noEvents': 'Geen evenementen gevonden',
  'races.failedToLoad': 'Racegegevens laden mislukt',
  'races.noData': 'Geen racegegevens beschikbaar',
  'races.position': 'Pos',
  'races.kart': '#',
  'races.driver': 'Rijder',
  'races.bestLap': 'Beste ronde',
  'races.totalTime': 'Totale tijd',
  'races.gap': 'Verschil',
  'races.status': 'Status',
  'races.grid': 'Grid',
  'races.lap': 'Ronde',
  'races.laps': 'Ronden',
  'races.penalty': 'Straf',
  'races.lapProgression': 'Rondeverloop',
  'races.results': 'Resultaten',
  'races.driverHistory': 'Rijdersgeschiedenis',
  'races.raceStarts': 'Starts',
  'races.podiums': 'Podiums',
  'races.dnfDsq': 'DNF / DSQ',
  'races.qualiPoles': 'Kwalificatie-poles',
  'races.track': 'Circuit',
  'races.session': 'Sessie',
  'races.year': 'Jaar',
  'races.category': 'Categorie',
  'races.pole': 'Pole',
  'races.winner': 'Winnaar',
  'races.finish': 'Finish',
  'races.sessionType.qualifying': 'Kwalificatie',
  'races.sessionType.heat-1': 'Heat 1',
  'races.sessionType.heat-2': 'Heat 2',
  'races.sessionType.heat-3': 'Heat 3',
  'races.sessionType.heat-ab': 'Heat A-B',
  'races.sessionType.heat-bc': 'Heat B-C',
  'races.sessionType.heat-ac': 'Heat A-C',
  'races.sessionType.final': 'Finale',

  // Race overview
  'races.overview': 'Overzicht',

  // Driver race search
  'races.searchPlaceholder': 'Zoek races… bijv. Castelletto of type:race',
  'races.querySyntaxHelp': 'Hulp bij zoeksyntax',
  'races.sessionCount': '{count} sessies',
  'races.sessionCountSingular': '1 sessie',
  'races.eventsFound': '{n} evenement(en) gevonden',

  // Session detail tabs (below results table)
  'races.sessionTabWeather': 'Weer',
  'races.sessionTabPace': 'Pace',
  'common.comingSoon': 'Binnenkort beschikbaar',

  // Driver pace
  'races.tabRaces': 'Races',
  'races.tabStats': 'Statistieken',
  'races.tabPace': 'Pace',
  'races.paceDescription': 'Snelste rondetijd per sessietype',
  'races.paceNoData': 'Geen pacegegevens beschikbaar voor deze categorie.',
  'races.paceEvents': '{n} evenementen',
  'races.paceQualifying': 'Beste rondetijd over alle evenementen',

  // Driver stats
  'races.statWins': 'Overwinningen',
  'races.statAvgFinish': 'Gem. finishpositie',
  'races.statSeasons': 'Seizoenen',
  'races.statTracks': 'Circuits',
  'races.statCategories': 'Categorieën',
  'races.statTotalLaps': 'Totaal aantal ronden',

  'driverSearchHelp.title': 'Zoeksyntax voor races',
  'driverSearchHelp.subtitle': 'Filter raceresultaten met veld:waarde-paren. Meerdere termen worden gecombineerd met EN.',
  'driverSearchHelp.bareText': '(vrije tekst)',
  'driverSearchHelp.bareTextDesc': 'Komt overeen met circuitnaam of kampioenschapsnaam die de tekst bevat.',
  'driverSearchHelp.track': 'track',
  'driverSearchHelp.trackDesc': 'Komt overeen met circuitnaam die de waarde bevat.',
  'driverSearchHelp.championship': 'championship',
  'driverSearchHelp.championshipDesc': 'Komt overeen met kampioenschapsnaam die de waarde bevat.',
  'driverSearchHelp.category': 'category',
  'driverSearchHelp.categoryDesc': 'Komt overeen met categorienaam die de waarde bevat.',
  'driverSearchHelp.type': 'type',
  'driverSearchHelp.typeDesc': 'Komt overeen met sessietype of label (bijv. race, qualifying, heat).',
  'driverSearchHelp.position': 'position',
  'driverSearchHelp.positionDesc': 'Filter op eindpositie. Ondersteunt =, >, >=, <, <= en bereiken.',
  'driverSearchHelp.laps': 'laps',
  'driverSearchHelp.lapsDesc': 'Filter op voltooide ronden. Ondersteunt vergelijkingsoperatoren en bereiken.',
  'driverSearchHelp.season': 'season',
  'driverSearchHelp.seasonDesc': 'Filter op kampioenschapsseizoen (jaar). Ondersteunt vergelijkingsoperatoren.',
  'driverSearchHelp.from': 'from',
  'driverSearchHelp.fromDesc': 'Races op of na een datum. Accepteert JJJJ-MM-DD of relatief: -7d, -2w, -3m, -1y.',
  'driverSearchHelp.to': 'to',
  'driverSearchHelp.toDesc': 'Races op of vóór een datum. Zelfde formaten als "from".',
  'driverSearchHelp.operatorsTitle': 'Operatoren & logica',
  'driverSearchHelp.numericComparisons': 'Numerieke vergelijkingen:',
  'driverSearchHelp.range': 'Bereik:',
  'driverSearchHelp.rangeDesc': '— komt overeen met waarden tussen 5 en 20 (inclusief).',
  'driverSearchHelp.booleanLogic': 'Booleaanse logica:',
  'driverSearchHelp.booleanLogicDesc': 'Termen worden impliciet gecombineerd met',
  'driverSearchHelp.quotes': 'Aanhalingstekens:',
  'driverSearchHelp.quotesDesc': 'Zet waarden met spaties tussen dubbele aanhalingstekens, bijv.',
  'driverSearchHelp.examplesTitle': 'Voorbeeldzoekopdrachten',
  'driverSearchHelp.example1Desc': 'Raceresultaten op Castelletto',
  'driverSearchHelp.example2Desc': 'Podiumplaatsen in het RMC-kampioenschap van het afgelopen jaar',
  'driverSearchHelp.example3Desc': 'Finaleresultaten in de top 3',

  // Drivers List Search Help
  'driversListSearchHelp.title': 'Rijders zoeken',
  'driversListSearchHelp.subtitle': 'Zoek rijders op naam',
  'driversListSearchHelp.bareText': 'Trefwoorden',
  'driversListSearchHelp.bareTextDesc': 'Trefwoorden worden vergeleken met voor- en achternaam. Meerdere trefwoorden worden als EN-voorwaarden behandeld.',
  'driversListSearchHelp.from': 'from',
  'driversListSearchHelp.fromDesc': 'Rijders actief op of na een datum. Accepteert JJJJ-MM-DD of relatief: -7d, -2w, -3m, -1y.',
  'driversListSearchHelp.to': 'to',
  'driversListSearchHelp.toDesc': 'Rijders actief op of vóór een datum. Zelfde formaten als "from".',
  'driversListSearchHelp.season': 'season',
  'driversListSearchHelp.seasonDesc': 'Rijders actief in een specifiek kampioenschapsseizoen. Ondersteunt vergelijkingsoperatoren zoals season:>2020.',
  'driversListSearchHelp.category': 'category',
  'driversListSearchHelp.categoryDesc': 'Rijders actief in een specifieke categorie (bijv. Rotax Max).',
  'driversListSearchHelp.example.yanick': 'Vind rijders met de naam Yanick',
  'driversListSearchHelp.example.senn': 'Vind rijders met de naam Senn',
  'driversListSearchHelp.example.from': 'Actieve rijders vanaf 2026',
  'driversListSearchHelp.example.season': 'Actieve rijders in 2025 of nieuwer',
  'driversListSearchHelp.example.category': 'Actieve rijders in Rotax Max',
  'drivers.lastAppearance': 'Laatste deelname',

  // Tyre Analysis
  'analysis.tyre.title': 'Bandenanalyse',
  'analysis.tyre.desc': 'Analyseer bandengeschiedenis en voorspel realistische rondetijden op basis van de huidige omstandigheden.',
  'tyre.selectTitle': 'Selecteer bandenset',
  'tyre.selectHint': 'Toont je meest recent gebruikte bandensets. Je kunt ook een barcode scannen.',
  'tyre.scanBarcode': 'Scannen',
  'tyre.barcodeSearch': 'Zoek op barcode of naam...',
  'tyre.fastestLaps': 'Snelste ronden per circuit',
  'tyre.expectations': 'Realistische verwachtingen',
  'tyre.totalLaps': 'Totaal gereden ronden',
  'tyre.totalSessions': 'Sessies',
  'tyre.longestSession': 'Langste sessie',
  'tyre.ageLaps': '{n} ronden',
  'tyre.noData': 'Geen gegevens',
  'tyre.expectedMedian': 'Verwacht',
  'tyre.matchingLaps': 'Overeenkomende ronden',
  'tyre.noTyresFound': 'Geen bandensets gevonden.',
  'tyre.noFastestLaps': 'Nog geen ronden geregistreerd met deze bandenset.',
  'tyre.noExpectations': 'Geen circuits met GPS-gegevens beschikbaar voor voorspellingen.',
  'tyre.dry': 'Droog',
  'tyre.wet': 'Nat',
  'tyre.pointCamera': 'Richt je camera op een barcode',
  'tyre.wizardSelect': 'Selecteer band',
  'tyre.wizardResults': 'Resultaten',
  'tyre.back': 'Terug',
  'tyre.exit': 'Afsluiten',
  'tyre.trackColumn': 'Circuit',
  'tyre.bestLapColumn': 'Beste ronde',
  'tyre.dateColumn': 'Datum',
  'tyre.ageColumn': 'Leeftijd',
  'tyre.weatherColumn': 'Weer',
  'tyre.tempColumn': 'Temp.',
  'tyre.expected': 'Verwacht:',

  // Tyre Overview
  'analysis.tyreOverview.title': 'Bandenoverzicht',
  'tyreOverview.summaryTotal': 'Totaal',
  'tyreOverview.summaryFresh': 'Nieuw',
  'tyreOverview.summaryWorn': 'Gebruikt',
  'tyreOverview.summaryEndOfLife': 'Versleten',
  'tyreOverview.endOfLife': '⚠ Versleten',
  'tyreOverview.scanButton': 'Scannen',
  'tyreOverview.noTyres': 'Geen actieve banden gevonden.',
  'tyreOverview.scanNotFound': 'Geen band gevonden voor de gescande barcode.',
  'tyreOverview.laps': 'ronden',
  'tyreOverview.colTyre': 'Band',
  'tyreOverview.colCompound': 'Compound',
  'tyreOverview.colLaps': 'Ronden',
  'tyreOverview.colLastUsed': 'Laatst gebruikt',
  'tyreOverview.colStatus': 'Status',
  'tyreOverview.discardButton': 'Markeren als afgeschreven',
  'tyreOverview.discardAction': 'Afschrijven',
  'tyreOverview.discardSuccess': 'Bandenset gemarkeerd als afgeschreven.',
  'tyreOverview.searchPlaceholder': 'Zoek banden (bijv. brand:Mojo compound:dry laps:<50)...',
  'tyreOverview.searchHelp.title': 'Bandenoverzicht zoeken',
  'tyreOverview.searchHelp.subtitle': 'Filter en vind actieve bandensets op merk, compound, ronden, barcode of circuit.',
  'tyreOverview.searchHelp.bareText': 'Tekst',
  'tyreOverview.searchHelp.bareTextDesc': 'Komt overeen met merk, type, volgnummer, barcode of laatst gebruikt circuit.',
  'tyreOverview.searchHelp.brandDesc': 'Filter op bandenfabrikant of merk (bijv. Mojo, Vega).',
  'tyreOverview.searchHelp.typeDesc': 'Filter op bandenmodel of type (bijv. D2, White).',
  'tyreOverview.searchHelp.nrDesc': 'Filter op referentienummer van de bandenset.',
  'tyreOverview.searchHelp.compoundDesc': 'Filter op compoundtype ("dry" of "wet").',
  'tyreOverview.searchHelp.lapsDesc': 'Filter op totaal aantal gereden ronden met vergelijkingsoperatoren (=, >, <, >=, <=) of bereiken (bijv. 0..20).',
  'tyreOverview.searchHelp.barcodeDesc': 'Filter op individuele bandenbarcode/serienummer.',
  'tyreOverview.searchHelp.trackDesc': 'Filter op circuitnaam waar de bandenset voor het laatst is gebruikt.',
  'tyreOverview.searchHelp.fromDesc': 'Komt overeen met banden die op of na een datum voor het laatst zijn gebruikt (JJJJ-MM-DD of relatief zoals -30d).',
  'tyreOverview.searchHelp.toDesc': 'Komt overeen met banden die op of vóór een datum voor het laatst zijn gebruikt (JJJJ-MM-DD of relatief zoals -1m).',
  'tyreOverview.searchHelp.example.mojoDry': 'Droogweerbanden van Mojo',
  'tyreOverview.searchHelp.example.lapsEol': 'Banden die het einde van hun levensduur hebben bereikt (70+ ronden)',
  'tyreOverview.searchHelp.example.lapsRange': 'Nieuwe of licht gebruikte banden met 0 tot 20 ronden',
  'tyreOverview.searchHelp.example.trackFrom': 'Banden laatst gebruikt op Lonato sinds 1 augustus 2026',
  'tyreOverview.searchHelp.example.vegaWet': 'Banden van Vega of regenbanden',

  // Devices
  'device.alfano7': 'Alfano 7',
  'device.mychron5': 'MyChron 5',

  // Import
  'import.title': 'Sessies importeren',
  'import.uploadZip': 'Telemetriebestanden uploaden',
  'import.uploadZipDesc': 'Upload Alfano 7 (ZIP) of MyChron 5 (.xrk, .xrz, ZIP) telemetriebestanden vanaf je computer',
  'import.dragDropZip': 'Sleep ZIP-, XRK- of XRZ-bestanden hierheen',
  'import.dropZipHere': 'Laat bestanden hier vallen',
  'import.orBrowse': 'of',
  'import.browseFiles': 'blader door bestanden',
  'import.filesSelected': '{n} bestand(en) geselecteerd',
  'import.upload': 'Uploaden',
  'import.uploading': 'Uploaden…',
  'import.uploadingPct': 'Uploaden… {n}%',
  'import.imported': 'Geïmporteerd',
  'import.skipped': 'Overgeslagen',
  'import.errors': 'Fouten',
  'import.errorDetailsTitle': 'Foutdetails',
  'import.successMessage': 'Sessies succesvol geïmporteerd. Ze verschijnen in je dashboard.',
  'import.noNewSessions': 'Geen nieuwe sessies gevonden. Alle bestanden waren al geïmporteerd.',
  'import.onlyZipAccepted': 'Alleen ZIP-, XRK- en XRZ-bestanden worden geaccepteerd',
  'import.onlySupportedAccepted': 'Alleen ZIP-, XRK- en XRZ-bestanden worden geaccepteerd',
  'import.uploadFailed': 'Uploaden mislukt (HTTP {status})',
  'import.connectionLost': 'Verbinding verbroken',
  'import.uploadAborted': 'Uploaden afgebroken',
  'import.importFailed': 'Importeren mislukt',
  'import.importedFromZip': '{n} sessie(s) geïmporteerd',
  'import.zipImportFailed': 'Importeren mislukt: {error}',
  'import.useCurrentSetup': 'Huidige setup gebruiken',
  'offline.title': 'Je bent offline',
  'offline.message': 'Je bent momenteel niet verbonden met het internet. Controleer je netwerkverbinding en probeer het opnieuw.',
  'settings.uploadSessions': 'Sessies uploaden',
  'settings.uploadSessionsDesc': 'Upload Alfano 7- of MyChron 5-telemetriebestanden om je sessiegegevens te importeren.',

  // Sharing
  'sharing.title': 'Delen',
  'sharing.searchPlaceholder': 'Zoek gebruikers op naam of e-mail...',
  'sharing.noUsersFound': 'Geen gebruikers gevonden',
  'sharing.shareAll': 'Alle sessies delen',
  'sharing.shareSelected': 'Alleen geselecteerde delen',
  'sharing.readOnly': 'Alleen-lezen',
  'sharing.readWrite': 'Lezen & schrijven',
  'sharing.share': 'Delen',
  'sharing.myShares': 'Mijn gedeelde items (uitgaand)',
  'sharing.sharedWithMe': 'Gedeeld met mij (inkomend)',
  'sharing.revoke': 'Intrekken',
  'sharing.leave': 'Verlaten',
  'sharing.permissions': 'Rechten',
  'sharing.sharedAll': 'Alle sessies',
  'sharing.sharedSelected': 'Geselecteerde sessies',
  'sharing.searching': 'Zoeken…',
  'sharing.owner': 'Eigenaar: {name}',
  'sharing.selectSessions': 'Selecteer sessies',
  'sharing.noSessions': 'Geen sessies beschikbaar',
  'sharing.laps': 'ronden',
  'sharing.searchHint': 'Typ minimaal 2 tekens om te zoeken',
  'sharing.newShare': 'Nieuw delen',
  'sharing.stepUsers': 'Stap 1: Selecteer gebruikers',
  'sharing.stepConfigure': 'Stap 2: Delen configureren',
  'sharing.stepPermissions': 'Stap 3: Rechten',
  'sharing.next': 'Volgende',
  'sharing.selectedUsers': 'Geselecteerde gebruikers',
  'sharing.selectedSessions': '{count} sessie(s) geselecteerd',
  'sharing.filterSessions': 'Sessies filteren...',
  'sharing.showSelected': 'Toon geselecteerde',
  'sharing.noSharesYet': 'Nog niets gedeeld',
  'sharing.emptyDescription': 'Deel je sessies met andere rijders of monteurs.',
  'sharing.stepScope': 'Stap 1: Selecteer sessies',
  'sharing.stepConfirm': 'Stap 2: Bevestigen',
  'sharing.shareWithTeam': 'Delen met dit team',

  // Setup (readonly view)
  'setup.noSetup': 'Geen setupgegevens beschikbaar voor deze sessie.',
  'setup.loadingSetup': 'Setup laden…',
  'setup.loadFailed': 'Setupgegevens laden mislukt.',
  'common.none': 'Geen',
  'common.notSet': 'Niet ingesteld',
  'nav.setupSections': 'Setup-onderdelen',
  // Pressure
  'pressure.tyre': 'Bandenset',
  'pressure.outgoing': 'Uitgaand',
  'pressure.cold': 'koud',
  'pressure.incoming': 'Inkomend',
  'pressure.hot': 'warm',
  'pressure.fl': 'LV',
  'pressure.fr': 'RV',
  'pressure.rl': 'LA',
  'pressure.rr': 'RA',
  // Front
  'front.caster': 'Caster',
  'front.camber': 'Camber',
  'front.trackWidth': 'Spoorbreedte voor',
  'front.trackWidthUnit': 'mm',
  'front.rideHeight': 'Rijhoogte voor',
  'front.frontHubs': 'Voornaven',
  'front.ackermann': 'Ackermann',
  'front.inner': 'Binnen',
  'front.outer': 'Buiten',
  'front.toeAlignment': 'Sporing (Toe)',
  'front.torsionBar': 'Torsiestang',
  'front.hard': 'Hard',
  'front.medium': 'Medium',
  'front.soft': 'Zacht',
  // Rear
  'rear.axle': 'Achteras',
  'rear.rearWidth': 'Spoorbreedte achter',
  'rear.rearHubs': 'Achternaven',
  'rear.loosenedBumper': 'Losgemaakte achterbumper',
  // Engine
  'engine.engine': 'Motor',
  'engine.sparkPlug': 'Bougie',
  'engine.gearRatio': 'Tandwielverhouding',
  'engine.pinion': 'Voortandwiel',
  'engine.crown': 'Achtertandwiel',
  // Carburetor
  'carb.carburetor': 'Carburateur',
  'carb.mainJet': 'Hoofdsproeier',
  'carb.idleJet': 'Stationairsproeier',
  'carb.needleClip': 'Gasnaaldclip',
  'carb.airScrew': 'Luchtschroef',
  'carb.floatHeight': 'Vlotterhoogte',
  // Chassis
  'chassisSelect.chassis': 'Chassis',
  'chassisSelect.weight': 'Gewicht',
  // Notes
  'notes.notes': 'Notities',
  'notes.placeholder': 'Setup-notities…',

  // Navigation – inventory
  'nav.inventory': 'Inventaris',
  'nav.organization': 'Organisatie',
  'nav.setup': 'Setup',

  // Materials — common
  'common.add': 'Toevoegen',
  'common.save': 'Opslaan',
  'common.create': 'Aanmaken',
  'common.created': 'Aangemaakt',
  'common.edit': 'Bewerken',
  'common.delete': 'Verwijderen',
  'common.optional': '(optioneel)',
  'common.brand': 'Merk',
  'common.type': 'Type',
  'materials.profile': 'Profiel',
  'materials.selectProfile': 'Selecteer profiel…',
  'common.nr': 'Nr.#',
  'common.nrInfo': 'Volgnummer om dit item te identificeren.',
  'common.team': 'Team',
  'common.year': 'Jaar',
  'common.stiffness': 'Stijfheid',
  'common.width': 'Breedte',
  'common.position': 'Positie',

  // Materials — CRUD
  'crud.requiredField': '{field} is verplicht',
  'crud.updated': '{entity} bijgewerkt',
  'crud.created': '{entity} aangemaakt',
  'crud.deleted': '{entity} verwijderd',
  'crud.confirmDelete': '{entity} "{name}" verwijderen?\nDit kan niet ongedaan worden gemaakt.',
  'crud.emptyState': 'Nog geen {title}. Voeg hierboven je eerste {entity} toe.',
  'crud.editEntity': '{entity} bewerken',
  'crud.newEntity': 'Nieuwe {entity}',

  // Materials — general
  'materials.readOnly': 'Alleen-lezen',
  'materials.selectTeam': 'Selecteer een team om de inventaris te bekijken.',

  // Materials — tabs
  'materials.tab.engines': 'Motoren',
  'materials.tab.tyres': 'Banden',
  'materials.tab.chassis': 'Chassis',
  'materials.tab.carburetors': 'Carburateurs',
  'materials.tab.axles': 'Assen',
  'materials.tab.hubs': 'Naven',
  'materials.tab.spark_plugs': 'Bougies',

  // Materials — entities
  'materials.entity.engine': 'Motor',
  'materials.entity.tyre': 'Band',
  'materials.entity.chassis': 'Chassis',
  'materials.entity.carburetor': 'Carburateur',
  'materials.entity.axle': 'As',
  'materials.entity.hub': 'Naaf',
  'materials.entity.spark_plug': 'Bougie',

  // Materials — tyre-specific
  'materials.tyre.compound': 'Compound',
  'materials.tyre.compound.dry': 'Droog',
  'materials.tyre.compound.wet': 'Nat',
  'materials.tyre.discarded': 'Afgeschreven',

  // Materials — tyre IDs
  'materials.tyreId.title': 'Banden-ID\'s',
  'materials.tyreId.fl': 'LV',
  'materials.tyreId.fr': 'RV',
  'materials.tyreId.rl': 'LA',
  'materials.tyreId.rr': 'RA',
  'materials.tyreId.scan': 'Barcode scannen',
  'materials.tyreId.duplicateInSet': 'Dubbele banden-ID binnen deze set',
  'materials.tyreId.duplicateInOtherSet': 'ID {id} wordt al gebruikt door {tyre}',
  'materials.tyreId.placeholder': 'Scan of voer banden-ID in',
  'materials.tyreId.crossSetInfo': 'Sommige banden-ID\'s conflicteren met andere bandensets. Druk nogmaals op Opslaan om te overschrijven.',

  // Materials — hub positions
  'materials.position.front': 'Voor',
  'materials.position.rear': 'Achter',
  // Setup editing
  'setup.edit': 'Setup bewerken',
  'setup.editTitle': 'Setup bewerken',
  'setup.save': 'Setup opslaan',
  'setup.saving': 'Opslaan…',
  'setup.saved': 'Setup opgeslagen',
  'setup.saveFailed': 'Setup opslaan mislukt',
  'setup.pageTitle': 'Huidige setup',
  'setup.pageSubtitle': 'Basisconfiguratie voor nieuw geïmporteerde sessies',
  'setup.editCurrentTitle': 'Huidige setup bewerken',
  'setup.noCurrentSetup': 'Nog geen setup geconfigureerd. Klik op "Setup bewerken" om te beginnen.',
  // Propagation
  'propagation.title': 'Wijzigingen toepassen',
  'propagation.subtitle': 'Pas setupwijzigingen toe op andere sessies',
  'propagation.changes': 'Wijzigingen',
  'propagation.sessions': 'Sessies',
  'propagation.selectAll': 'Alles selecteren',
  'propagation.deselectAll': 'Alles deselecteren',
  'propagation.apply': 'Toepassen',
  'propagation.applying': 'Toepassen…',
  'propagation.applied': 'Toegepast op sessies',
  'propagation.skip': 'Overslaan',
  'propagation.selectAtLeastOne': 'Selecteer ten minste één sessie',
  'propagation.noMatching': 'Geen overeenkomende sessies gevonden',
  // Propagation field labels
  'propagation.field.chassis': 'Chassis',
  'propagation.field.weight': 'Gewicht',
  'propagation.field.engine': 'Motor',
  'propagation.field.tyre': 'Band',
  'propagation.field.carburetor': 'Carburateur',
  'propagation.field.axle': 'Achteras',
  'propagation.field.flOut': 'LV uit',
  'propagation.field.frOut': 'RV uit',
  'propagation.field.rlOut': 'LA uit',
  'propagation.field.rrOut': 'RA uit',
  'propagation.field.flIn': 'LV in',
  'propagation.field.frIn': 'RV in',
  'propagation.field.rlIn': 'LA in',
  'propagation.field.rrIn': 'RA in',
  'propagation.field.rearWidth': 'Spoorbreedte achter',
  'propagation.field.frontHubs': 'Voornaven',
  'propagation.field.rearHubs': 'Achternaven',
  'propagation.field.rearBumper': 'Achterbumper',
  'propagation.field.caster': 'Caster',
  'propagation.field.camber': 'Camber',
  'propagation.field.trackWidth': 'Spoorbreedte voor',
  'propagation.field.rideHeight': 'Rijhoogte voor',
  'propagation.field.ackermann': 'Ackermann',
  'propagation.field.toe': 'Sporing (Toe)',
  'propagation.field.torsionBar': 'Torsiestang',
  'propagation.field.frontSprocket': 'Voortandwiel',
  'propagation.field.rearSprocket': 'Achtertandwiel',
  'propagation.field.mainJet': 'Hoofdsproeier',
  'propagation.field.idleJet': 'Stationairsproeier',
  'propagation.field.needleClip': 'Gasnaaldclip',
  'propagation.field.airScrew': 'Luchtschroef',
  'propagation.field.floatHeight': 'Vlotterhoogte',
  'propagation.field.notes': 'Notities',
  'propagation.field.sparkPlug': 'Bougie',
  // Common additions
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.skip': 'Overslaan',
  'common.applying': 'Toepassen…',

  // Teams
  'nav.teams': 'Teams',
  'team.subtitle': 'Beheer je teams en leden',
  'team.create': 'Team aanmaken',
  'team.name': 'Teamnaam',
  'team.members': 'Leden',
  'team.role.read': 'Lezen',
  'team.role.write': 'Schrijven',
  'team.role.manage': 'Beheren',
  'team.role.owner': 'Eigenaar',
  'team.addMember': 'Lid toevoegen',
  'team.removeMember': 'Lid verwijderen',
  'team.leave': 'Team verlaten',
  'team.confirmLeave': 'Weet je zeker dat je dit team wilt verlaten?',
  'team.cannotLeaveOwner': 'Je kunt het team niet verlaten omdat je de eigenaar bent.',
  'team.created': 'Team aangemaakt',
  'team.memberAdded': 'Lid toegevoegd',
  'team.memberRemoved': 'Lid verwijderd',
  'team.roleUpdated': 'Rol bijgewerkt',
  'team.renamed': 'Teamnaam gewijzigd',
  'team.empty': 'Geen teams gevonden. Maak er een aan om te beginnen.',
  'team.noWriteAccess': 'Je hebt geen schrijftoegang tot dit team.',
  'team.tab.members': 'Leden',
  'team.tab.sharing': 'Gedeeld',
  'team.members.searchPlaceholder': 'Zoek leden...',
  'team.sharing.searchPlaceholder': 'Zoek gedeelde items...',
  'team.members.searchTitle': 'Leden zoeken',
  'team.members.searchSubtitle': 'Filter leden op naam, e-mail of rol',
  'team.sharing.searchTitle': 'Gedeelde items zoeken',
  'team.sharing.searchSubtitle': 'Filter gedeelde items op eigenaar of type',
  'team.members.field.bareText': '(vrije tekst)',
  'team.members.field.bareTextDesc': 'Zoekt op naam',
  'team.members.field.name': 'name:',
  'team.members.field.nameDesc': 'Filter op naam van lid',
  'team.members.field.role': 'role:',
  'team.members.field.roleDesc': 'Filter op rol (read, write, manage)',
  'team.sharing.field.bareText': '(vrije tekst)',
  'team.sharing.field.bareTextDesc': 'Zoekt op naam van eigenaar',
  'team.sharing.field.owner': 'owner:',
  'team.sharing.field.ownerDesc': 'Filter op eigenaar van gedeeld item',
  'team.sharing.field.type': 'type:',
  'team.sharing.field.typeDesc': 'Filter op type (all, selected)',

  // Lap Diff Analysis
  'analysis.lapdiff.title': 'Rondevergelijking',
  'analysis.lapdiff.desc': 'Leg twee ronden over elkaar en markeer verschillen in snelheid, RPM en acceleratie.',
  'lapdiff.selectHint': 'Selecteer precies 2 ronden om te vergelijken.',
  'lapdiff.compare': 'Vergelijken',
  'lapdiff.comparing': 'Vergelijken…',
  'lapdiff.viewLapA': 'Bekijk ronde A',
  'lapdiff.viewLapB': 'Bekijk ronde B',
  'lapdiff.tabTime': 'Tijd',
  'lapdiff.tabSpeed': 'Snelheid',
  'lapdiff.tabRpm': 'RPM',
  'lapdiff.tabAcceleration': 'Acceleratie',
  'lapdiff.timeChartTitle': 'Verloren tijd op basis van baanpositie',
  'lapdiff.timeGained': 'Tijd gewonnen',
  'lapdiff.timeLost': 'Tijd verloren',
  'lapdiff.cumulativeDelta': 'Cumulatieve Δt',
  'lapdiff.segmentDelta': 'Segment Δt',
  'lapdiff.trackPosition': 'Baanpositie',
  'lapdiff.avgDiff': 'Gem. verschil',
  'lapdiff.maxDiff': 'Max. verschil',
  'lapdiff.noGpsData': 'Geen GPS-gegevens beschikbaar voor vergelijking.',
  'lapdiff.pctBetter': '% beter',
  'lapdiff.segmentTime': 'Segment',
  'lapdiff.fullLap': 'Volledige ronde',
  'lapdiff.fasterBy': '{lap} sneller met {time}',
  'lapdiff.equalTime': 'Gelijke tijd',
  'lapdiff.clearAnchors': 'Ankers wissen',
  'lapdiff.clickToPlace': 'Klik op de baan om ankers te plaatsen',
  'lapdiff.segmentRange': 'Segmenten #{start} – #{end}',
  'lapdiff.segmentDetail': 'Segment #{index}',

  // Aggregation Analysis
  'analysis.aggregation.title': 'Aggregatie',
  'analysis.aggregation.desc': 'Aggregeer rem-, acceleratie- en schakelpunten over meerdere sessies op een circuitkaart.',
  'aggregation.brakingPoints': 'Remmen',
  'aggregation.accelerationPoints': 'Acceleratie',
  'aggregation.upshiftPoints': 'Opschakelen',
  'aggregation.top10Title': 'Top 10 snelste ronden',
  'aggregation.noData': 'Geen datapunten gedetecteerd',
  'aggregation.noDataHint': 'Probeer andere sessies te selecteren.',
  'aggregation.trackShapeRequired': 'Circuitvorm vereist',
  'aggregation.trackShapeRequiredHint': 'Een officiële circuitvorm is vereist om aggregatie-boxplots weer te geven. Maak een circuitvorm aan in de editor.',
  'aggregation.sessionSelectionHint': 'Hoe meer sessies er worden opgenomen, hoe hoger de kwaliteit en nauwkeurigheid van de geaggregeerde zones.',
  'aggregation.brakingSegment': 'Remzone',
  'aggregation.accelerationSegment': 'Acceleratiezone',
  'aggregation.upshiftSegment': 'Opschakelzone',
  'aggregation.tooltipSamples': ({ count }) => `${count} metingen`,
  'aggregation.tooltipMedian': 'Mediaan',
  'aggregation.tooltipSpread': 'Spreiding',
  'aggregation.gpsHeatmap': 'GPS-heatmap',
  'aggregation.eventZones': 'Actiezones',
  'aggregation.heatmapLow': 'Laag',
  'aggregation.heatmapHigh': 'Hoog',
  'aggregation.selectedLapLine': 'Geselecteerde ronde',
  'aggregation.lapsIncluded': '{count} ronden',
  'gearshifting.wizardChooseTrack': 'Kies circuit',
  'gearshifting.wizardSelect': 'Selecteer sessies',
  'gearshifting.wizardResults': 'Resultaten',
  'gearshifting.analyzingLap': 'Analyseren…',

  // Aggregation Diff Analysis
  'analysis.aggregationdiff.title': 'Aggregatievergelijking',
  'analysis.aggregationdiff.desc': 'Vergelijk twee sessie-aggregaties om verschillen in rijlijn, remmen, accelereren en schakelen zichtbaar te maken.',
  'aggregationdiff.groupA': 'Groep A',
  'aggregationdiff.groupB': 'Groep B',
  'aggregationdiff.baseline': 'Referentie',
  'aggregationdiff.comparison': 'Vergelijking',
  'aggregationdiff.groupLabelPlaceholder': 'Aangepast label (bijv. Ochtend droog)',
  'aggregationdiff.loadSavedAggregation': 'Laden uit opgeslagen aggregatie…',
  'aggregationdiff.selectHint': 'Selecteer sessies voor Groep A (Referentie) en Groep B (Vergelijking) om verschillen in rijlijn, remmen, accelereren en schakelen te markeren.',
  'aggregationdiff.selectHintA': 'Configureer Groep A (Referentie) door een enkele ronde of een of meer sessies te selecteren.',
  'aggregationdiff.selectHintB': 'Configureer Groep B (Vergelijking) door een enkele ronde of een of meer sessies te selecteren om te vergelijken met Groep A.',
  'aggregationdiff.compare': 'Aggregaties vergelijken',
  'aggregationdiff.bestLap': 'Beste ronde',
  'aggregationdiff.medianLap': 'Mediaan ronde',
  'aggregationdiff.consistency': 'Consistentie (σ)',
  'aggregationdiff.lapsAndSessions': '{laps} ronden · {sessions} sessies',
  'aggregationdiff.layerDiffHeatmap': 'Lijnverschil-heatmap',
  'aggregationdiff.layerMedianLines': 'Mediaanlijnen',
  'aggregationdiff.layerEventDiffs': 'Verschillen actiezones',
  'aggregationdiff.hideUnchanged': 'Dim < 1,5m',
  'aggregationdiff.keyDifferencesTitle': 'Belangrijkste verschillen',
  'aggregationdiff.keyDifferencesSubtitle': ' Baansecties gesorteerd op tijdsverschil met mogelijke oorzaken. Klik op een sectie om in te zoomen op de kaart.',
  'aggregationdiff.filterAll': 'Alles',
  'aggregationdiff.filterLine': 'Rijlijn',
  'aggregationdiff.filterBraking': 'Remmen',
  'aggregationdiff.filterAcceleration': 'Acceleratie',
  'aggregationdiff.filterUpshift': 'Opschakelen',
  'aggregationdiff.filterTopSpeed': 'Topsnelheid',
  'aggregationdiff.possibleReasons': 'Mogelijke oorzaken',
  'aggregationdiff.topSpeedPeak': 'Piek {a} vs {b} km/h',
  'aggregationdiff.laterBy': '{group} {dist}m later',
  'aggregationdiff.earlierBy': '{group} {dist}m eerder',
  'aggregationdiff.widerBy': 'Spreiding +{dist}m breder',
  'aggregationdiff.tighterBy': 'Spreiding {dist}m kleiner',
  'aggregationdiff.onlyInGroup': 'Alleen in {group}',
  'aggregationdiff.lineSeparation': '{dist}m max. lijnafstand ({len}m zone)',
  'aggregationdiff.lineOffsetLeft': 'Links +{dist}m',
  'aggregationdiff.lineOffsetRight': 'Rechts +{dist}m',
  'aggregationdiff.noSignificantDiffs': 'Geen significante verschillen gevonden voor dit filter.',
  'aggregationdiff.sharedLine': 'Gedeelde lijn',
  'aggregationdiff.clearFocus': 'Selectie wissen',
  'aggregationdiff.avgSpeed': 'Gem. snelheid',
  'aggregationdiff.speedDiff': 'Snelheidsverschil',
  'aggregationdiff.lineOffset': 'Lijnafwijking',
  'aggregationdiff.layerFasterSegments': 'Snellere segmenten',
  'aggregationdiff.fasterSegmentLegend': 'Sneller segment (snelheid)',
  'aggregationdiff.estTimeGained': '{group} sneller met {time}',
  'aggregationdiff.estTimeLost': '{group} sneller met {time}',
  'aggregationdiff.estTimeNeutral': 'Gesch. ±0,00s',

  // Analysis History
  'analysis.history.title': 'Analysegeschiedenis',
  'analysis.history.subtitle': 'Heropen en beheer eerder uitgevoerde telemetrieanalyses',
  'analysis.history.filterAll': 'Alle tools',
  'analysis.history.filterSector': 'Sector',
  'analysis.history.filterCorner': 'Bocht',
  'analysis.history.filterBraking': 'Remmen',
  'analysis.history.filterLapDiff': 'Rondevergelijking',
  'analysis.history.filterAggregation': 'Aggregatie',
  'analysis.history.filterAggregationDiff': 'Aggregatievergelijking',
  'analysis.history.groupsScope': '{a} vs {b} sessie(s)',
  'analysis.history.empty': 'Geen opgeslagen analyses gevonden',
  'analysis.history.emptyDesc': 'Analyses die je uitvoert terwijl je bent ingelogd, verschijnen hier automatisch.',
  'analysis.history.open': 'Openen',
  'analysis.history.rename': 'Hernoemen',
  'analysis.history.delete': 'Verwijderen',
  'analysis.history.deleteConfirm': 'Weet je zeker dat je deze analyse uit de geschiedenis wilt verwijderen?',
  'analysis.history.deleteSuccess': 'Analyse verwijderd',
  'analysis.history.renameSuccess': 'Analyse hernoemd',
  'analysis.history.searchPlaceholder': 'Zoek in analysegeschiedenis...',
  'analysis.history.loading': 'Analyses laden...',
  'analysis.history.table.type': 'Type',
  'analysis.history.table.name': 'Naam',
  'analysis.history.table.track': 'Circuit',
  'analysis.history.table.scope': 'Bereik',
  'analysis.history.table.created': 'Aangemaakt',
  'analysis.history.table.actions': 'Acties',
  'analysis.history.total': '{n} totaal',
  'analysis.history.sessionsCount': '{n} sessie(s)',
  'analysis.history.lapsCount': '{n} ronde(n)',
  'analysis.history.viewAll': 'Volledige geschiedenis bekijken',
  'analysis.sessionRemoved.title': 'Sessie verwijderd',
  'analysis.sessionRemoved.description': 'De telemetriesessie die door deze analyse wordt gebruikt, is verwijderd waardoor deze analyse niet meer kan worden geopend.',
  'analysis.sessionRemoved.deleteAnalysis': 'Analyse verwijderen',
  'analysis.sessionRemoved.close': 'Sluiten',

  /* ── Footer ──── */
  'footer.contact': 'Contact',
  'footer.privacyPolicy': 'Privacybeleid',
  'footer.reportBug': 'Bug melden',
  'footer.bugReportTitle': 'Bug melden',
  'footer.description': 'Beschrijving',
  'footer.descriptionPlaceholder': 'Beschrijf het probleem dat je bent tegengekomen...',
  'footer.submit': 'Verzenden',
  'footer.submitting': 'Verzenden...',
  'footer.submitted': 'Bugrapport verzonden. Bedankt!',
  'footer.submitFailed': 'Verzenden van bugrapport mislukt.',

  /* ── Error auto-reporting & Error Boundary ─────────────────────────── */
  'error.autoReported': 'Er is een fout opgetreden en deze is automatisch gemeld.',
  'errorBoundary.title': 'Er ging iets mis',
  'errorBoundary.message': 'Er is een onverwachte fout opgetreden en deze is gemeld aan de server.',
  'errorBoundary.reload': 'Pagina herladen',
  'errorBoundary.reset': 'Opnieuw proberen',
  'errorBoundary.showDetails': 'Foutdetails tonen',
  'errorBoundary.hideDetails': 'Foutdetails verbergen',

  /* ── Setup Coach ──────────────────────────────────────────── */
  'coach.title': 'Setup Coach',
  'coach.subtitle': 'Een kennisbank met kart-setupaanpassingen geordend per rijdoel. Selecteer een probleem om aanbevolen wijzigingen en hun effecten te bekijken.',
  'coach.disclaimer': 'Deze aanbevelingen zijn algemene richtlijnen voor Rotax Max-karts. Test wijzigingen altijd stap voor stap en pas ze aan op basis van baanomstandigheden, feedback van de rijder en de staat van de banden.',
  'coach.col.parameter': 'Parameter',
  'coach.col.change': 'Aanpassing',
  'coach.col.effect': 'Effect',
  'coach.col.sideEffects': 'Neveneffecten',
  'coach.col.effectiveness': 'Effectiviteit',

  // Reduce Understeer
  'coach.goal.understeer.title': 'Onderstuur verminderen',
  'coach.goal.understeer.desc': 'De kart schuift over de voorwielen naar buiten in bochten en volgt niet de gewenste rijlijn. De voorbanden verliezen eerder grip dan de achterbanden, waardoor de kart traag reageert op stuurbewegingen.',
  'coach.goal.understeer.adj1.param': 'Spoorbreedte voor',
  'coach.goal.understeer.adj1.change': 'Verbreden',
  'coach.goal.understeer.adj1.effect': 'Meer mechanische grip aan de voorkant',
  'coach.goal.understeer.adj1.side': 'Kan de voorkant agressiever maken',
  'coach.goal.understeer.adj2.param': 'Caster voor',
  'coach.goal.understeer.adj2.change': 'Vergroten',
  'coach.goal.understeer.adj2.effect': 'Meer grip aan de voorkant bij het insturen',
  'coach.goal.understeer.adj2.side': 'Minder rechtuitstabiliteit',
  'coach.goal.understeer.adj3.param': 'Camber voor',
  'coach.goal.understeer.adj3.change': 'Toevoegen (meer negatief)',
  'coach.goal.understeer.adj3.effect': 'Meer grip aan de voorkant midden in de bocht',
  'coach.goal.understeer.adj3.side': 'Ongelijkmatige bandenslijtage',
  'coach.goal.understeer.adj4.param': 'Rijhoogte voor',
  'coach.goal.understeer.adj4.change': 'Verlagen',
  'coach.goal.understeer.adj4.effect': 'Lager zwaartepunt, meer grip',
  'coach.goal.understeer.adj4.side': 'Risico op raken van het asfalt',
  'coach.goal.understeer.adj5.param': 'Achteras',
  'coach.goal.understeer.adj5.change': 'Zachter (minder stijf)',
  'coach.goal.understeer.adj5.effect': 'Maakt de achterkant losser om te roteren',
  'coach.goal.understeer.adj5.side': 'Kan onrust aan de achterkant veroorzaken',
  'coach.goal.understeer.adj6.param': 'Bandenspanning voor',
  'coach.goal.understeer.adj6.change': 'Iets verhogen',
  'coach.goal.understeer.adj6.effect': 'Scherpere stuurrespons voor',
  'coach.goal.understeer.adj6.side': 'Kleiner contactoppervlak',

  // Reduce Oversteer
  'coach.goal.oversteer.title': 'Overstuur verminderen',
  'coach.goal.oversteer.desc': 'De achterkant van de kart breekt uit in bochten, waardoor de kart te agressief roteert. De achterbanden verliezen eerder grip dan de voorbanden, wat leidt tot plotseling overstuur of een losse achterkant.',
  'coach.goal.oversteer.adj1.param': 'Spoorbreedte voor',
  'coach.goal.oversteer.adj1.change': 'Versmallen',
  'coach.goal.oversteer.adj1.effect': 'Minder grip voor, brengt wegligging in balans',
  'coach.goal.oversteer.adj1.side': 'Minder stuurrespons',
  'coach.goal.oversteer.adj2.param': 'Caster voor',
  'coach.goal.oversteer.adj2.change': 'Verminderen',
  'coach.goal.oversteer.adj2.effect': 'Minder grip aan de voorkant',
  'coach.goal.oversteer.adj2.side': 'Trager insturen',
  'coach.goal.oversteer.adj3.param': 'Achteras',
  'coach.goal.oversteer.adj3.change': 'Stijver maken',
  'coach.goal.oversteer.adj3.effect': 'Meer grip aan de achterkant',
  'coach.goal.oversteer.adj3.side': 'Chassis kan gaan stuiteren op hobbels',
  'coach.goal.oversteer.adj4.param': 'Spoorbreedte achter',
  'coach.goal.oversteer.adj4.change': 'Verbreden',
  'coach.goal.oversteer.adj4.effect': 'Meer mechanische grip achter',
  'coach.goal.oversteer.adj4.side': 'Minder rotatie van de achterkant',
  'coach.goal.oversteer.adj5.param': 'Bandenspanning achter',
  'coach.goal.oversteer.adj5.change': 'Iets verlagen',
  'coach.goal.oversteer.adj5.effect': 'Groter contactoppervlak achter',
  'coach.goal.oversteer.adj5.side': 'Langzamere opwarming van de banden',
  'coach.goal.oversteer.adj6.param': 'Torsiestang voor',
  'coach.goal.oversteer.adj6.change': 'Toevoegen',
  'coach.goal.oversteer.adj6.effect': 'Maakt voorkant stijver, vermindert grip voor',
  'coach.goal.oversteer.adj6.side': 'Minder flexibiliteit aan de voorkant',

  // Chassis Bounce
  'coach.goal.bounce.title': 'Chassis stuitert in bochten',
  'coach.goal.bounce.desc': 'Het chassis stuitert of hopt door bochten in plaats van vloeiend contact met de baan te houden. Dit wordt meestal veroorzaakt doordat het chassis te stijf is ten opzichte van het gripniveau, waardoor het onmogelijk is om een constante snelheid door de bocht aan te houden.',
  'coach.goal.bounce.adj1.param': 'Achteras',
  'coach.goal.bounce.adj1.change': 'Zachter (minder stijf)',
  'coach.goal.bounce.adj1.effect': 'Absorbeert energie, maakt wegligging rustiger',
  'coach.goal.bounce.adj1.side': 'Kan grip aan de achterkant verminderen',
  'coach.goal.bounce.adj2.param': 'Spoorbreedte achter',
  'coach.goal.bounce.adj2.change': 'Verbreden',
  'coach.goal.bounce.adj2.effect': 'Stabiliseert het chassis door de bocht',
  'coach.goal.bounce.adj2.side': 'Minder rotatie bij het uitkomen',
  'coach.goal.bounce.adj3.param': 'Achterbumper',
  'coach.goal.bounce.adj3.change': 'Losmaken',
  'coach.goal.bounce.adj3.effect': 'Geeft meer flex, absorbeert trillingen',
  'coach.goal.bounce.adj3.side': 'Minder stijve ondersteuning',
  'coach.goal.bounce.adj4.param': 'Bandenspanning achter',
  'coach.goal.bounce.adj4.change': 'Verlagen',
  'coach.goal.bounce.adj4.effect': 'Meer demping over hobbels',
  'coach.goal.bounce.adj4.side': 'Tragere respons',
  'coach.goal.bounce.adj5.param': 'Rijhoogte voor',
  'coach.goal.bounce.adj5.change': 'Verhogen',
  'coach.goal.bounce.adj5.effect': 'Meer bodemvrijheid van het chassis',
  'coach.goal.bounce.adj5.side': 'Minder grip aan de voorkant',

  // Reduce Front Aggressiveness
  'coach.goal.frontAggressive.title': 'Agressiviteit aan de voorkant verminderen',
  'coach.goal.frontAggressive.desc': 'De voorkant heeft te veel grip, waardoor de kart te scherp instuurt en de achterkant onrustig maakt. De kart voelt nerveus aan bij het ingaan van de bocht en kan plotseling uitbreken in overstuur.',
  'coach.goal.frontAggressive.adj1.param': 'Spoorbreedte voor',
  'coach.goal.frontAggressive.adj1.change': 'Versmallen',
  'coach.goal.frontAggressive.adj1.effect': 'Vermindert grip aan de voorkant',
  'coach.goal.frontAggressive.adj1.side': 'Meer neiging tot onderstuur',
  'coach.goal.frontAggressive.adj2.param': 'Caster voor',
  'coach.goal.frontAggressive.adj2.change': 'Verminderen',
  'coach.goal.frontAggressive.adj2.effect': 'Minder directe bite bij het insturen',
  'coach.goal.frontAggressive.adj2.side': 'Trager insturen',
  'coach.goal.frontAggressive.adj3.param': 'Torsiestang voor',
  'coach.goal.frontAggressive.adj3.change': 'Verwijderen of zachter maken',
  'coach.goal.frontAggressive.adj3.effect': 'Maakt de voorkant zachter',
  'coach.goal.frontAggressive.adj3.side': 'Voorkant kan minder precies aanvoelen',
  'coach.goal.frontAggressive.adj4.param': 'Camber voor',
  'coach.goal.frontAggressive.adj4.change': 'Verminderen (minder negatief)',
  'coach.goal.frontAggressive.adj4.effect': 'Minder bochtengrip',
  'coach.goal.frontAggressive.adj4.side': 'Gelijkmatigere bandenslijtage',
  'coach.goal.frontAggressive.adj5.param': 'Bandenspanning voor',
  'coach.goal.frontAggressive.adj5.change': 'Verhogen',
  'coach.goal.frontAggressive.adj5.effect': 'Kleiner contactoppervlak',
  'coach.goal.frontAggressive.adj5.side': 'Directer maar minder totale grip',

  // Reduce Rear Sliding
  'coach.goal.rearSlide.title': 'Glijden van de achterkant verminderen',
  'coach.goal.rearSlide.desc': 'De achterkant van de kart glijdt overmatig in bochten, wat zorgt voor tijdsverlies en hoge bandenslijtage. De kart mist tractie achter en voelt instabiel aan onder zijwaartse belasting.',
  'coach.goal.rearSlide.adj1.param': 'Achteras',
  'coach.goal.rearSlide.adj1.change': 'Stijver maken',
  'coach.goal.rearSlide.adj1.effect': 'Meer grip aan de achterkant',
  'coach.goal.rearSlide.adj1.side': 'Kan stuiteren op hobbels',
  'coach.goal.rearSlide.adj2.param': 'Spoorbreedte achter',
  'coach.goal.rearSlide.adj2.change': 'Verbreden',
  'coach.goal.rearSlide.adj2.effect': 'Meer mechanische grip achter',
  'coach.goal.rearSlide.adj2.side': 'Minder vrije rotatie',
  'coach.goal.rearSlide.adj3.param': 'Bandenspanning achter',
  'coach.goal.rearSlide.adj3.change': 'Iets verhogen',
  'coach.goal.rearSlide.adj3.effect': 'Betere bandvorm onder belasting',
  'coach.goal.rearSlide.adj3.side': 'Kleiner contactoppervlak op de limiet',
  'coach.goal.rearSlide.adj4.param': 'Spoorbreedte voor',
  'coach.goal.rearSlide.adj4.change': 'Versmallen',
  'coach.goal.rearSlide.adj4.effect': 'Brengt gripverdeling in balans',
  'coach.goal.rearSlide.adj4.side': 'Minder bite aan de voorkant',
  'coach.goal.rearSlide.adj5.param': 'Achternaven',
  'coach.goal.rearSlide.adj5.change': 'Langere naven gebruiken',
  'coach.goal.rearSlide.adj5.effect': 'Meer hefboomwerking op de achteras',
  'coach.goal.rearSlide.adj5.side': 'Zwaarder stuurgevoel',

  // Corner Exit Traction
  'coach.goal.cornerExit.title': 'Tractie bij uitkomen van de bocht verbeteren',
  'coach.goal.cornerExit.desc': 'De kart heeft moeite om het vermogen kwijt te kunnen bij het uitkomen van de bocht, waarbij de achterbanden doorslippen of wegglijden bij het accelereren uit langzame bochten. Dit kost tijd op het rechte stuk dat volgt.',
  'coach.goal.cornerExit.adj1.param': 'Spoorbreedte achter',
  'coach.goal.cornerExit.adj1.change': 'Verbreden',
  'coach.goal.cornerExit.adj1.effect': 'Meer mechanische grip bij het uitkomen',
  'coach.goal.cornerExit.adj1.side': 'Minder rotatie midden in de bocht',
  'coach.goal.cornerExit.adj2.param': 'Achteras',
  'coach.goal.cornerExit.adj2.change': 'Stijver maken',
  'coach.goal.cornerExit.adj2.effect': 'Drukt de achterkant op het asfalt bij accelereren',
  'coach.goal.cornerExit.adj2.side': 'Kan stuiteren onder belasting',
  'coach.goal.cornerExit.adj3.param': 'Bandenspanning achter',
  'coach.goal.cornerExit.adj3.change': 'Verlagen',
  'coach.goal.cornerExit.adj3.effect': 'Groter contactoppervlak bij het uitkomen',
  'coach.goal.cornerExit.adj3.side': 'Langzamere opwarming van de banden',
  'coach.goal.cornerExit.adj4.param': 'Achtertandwiel',
  'coach.goal.cornerExit.adj4.change': 'Vergroten (meer tanden)',
  'coach.goal.cornerExit.adj4.effect': 'Meer trekkracht onderin',
  'coach.goal.cornerExit.adj4.side': 'Lagere topsnelheid',
  'coach.goal.cornerExit.adj5.param': 'Achterbumper',
  'coach.goal.cornerExit.adj5.change': 'Losmaken',
  'coach.goal.cornerExit.adj5.effect': 'Meer flex onder belasting',
  'coach.goal.cornerExit.adj5.side': 'Minder voorspelbaar',

  // Hot Conditions
  'coach.goal.hotConditions.title': 'Aanpassen aan warme omstandigheden',
  'coach.goal.hotConditions.desc': 'De baantemperatuur is hoog, wat zorgt voor meer grip en oververhitting van de banden. Het chassis kan te veel grip krijgen, wat leidt tot stuiteren of een te agressieve voorkant. De motor loopt warmer en een rijker mengsel kan nodig zijn.',
  'coach.goal.hotConditions.adj1.param': 'Alle bandenspanningen',
  'coach.goal.hotConditions.adj1.change': 'Verhogen',
  'coach.goal.hotConditions.adj1.effect': 'Compenseert voor uitzetting door hitte',
  'coach.goal.hotConditions.adj1.side': 'Kan grip verminderen als de spanning te hoog wordt',
  'coach.goal.hotConditions.adj2.param': 'Hoofdsproeier',
  'coach.goal.hotConditions.adj2.change': 'Rijker zetten (groter nummer)',
  'coach.goal.hotConditions.adj2.effect': 'Voorkomt een te arm mengsel',
  'coach.goal.hotConditions.adj2.side': 'Licht vermogensverlies',
  'coach.goal.hotConditions.adj3.param': 'Achteras',
  'coach.goal.hotConditions.adj3.change': 'Zachter maken',
  'coach.goal.hotConditions.adj3.effect': 'Compenseert voor het hogere gripniveau',
  'coach.goal.hotConditions.adj3.side': 'Kan los aanvoelen',
  'coach.goal.hotConditions.adj4.param': 'Spoorbreedte achter',
  'coach.goal.hotConditions.adj4.change': 'Iets versmallen',
  'coach.goal.hotConditions.adj4.effect': 'Vermindert overtollige grip achter',
  'coach.goal.hotConditions.adj4.side': 'Minder tractie bij het uitkomen',
  'coach.goal.hotConditions.adj5.param': 'Luchtschroef',
  'coach.goal.hotConditions.adj5.change': 'Openen (meer slagen uit)',
  'coach.goal.hotConditions.adj5.effect': 'Rijker stationair mengsel',
  'coach.goal.hotConditions.adj5.side': 'Kan stationair lopen beïnvloeden',

  // Cold/Wet Conditions
  'coach.goal.coldConditions.title': 'Aanpassen aan koude / natte omstandigheden',
  'coach.goal.coldConditions.desc': 'De baantemperatuur is laag of het asfalt is nat, waardoor er veel minder grip is. De kart heeft maximale mechanische grip nodig en de carburateurafstelling moet compenseren voor koudere, dichtere lucht. Voer wijzigingen voorzichtig door en stel veiligheid voorop.',
  'coach.goal.coldConditions.adj1.param': 'Alle bandenspanningen',
  'coach.goal.coldConditions.adj1.change': 'Verlagen',
  'coach.goal.coldConditions.adj1.effect': 'Compenseert voor krimp bij kou',
  'coach.goal.coldConditions.adj1.side': 'Risico dat de band van de velg loopt',
  'coach.goal.coldConditions.adj2.param': 'Hoofdsproeier',
  'coach.goal.coldConditions.adj2.change': 'Armer zetten (kleiner nummer)',
  'coach.goal.coldConditions.adj2.effect': 'Compenseert voor dichtere lucht',
  'coach.goal.coldConditions.adj2.side': 'Risico op oververhitting van de motor',
  'coach.goal.coldConditions.adj3.param': 'Achteras',
  'coach.goal.coldConditions.adj3.change': 'Stijver maken',
  'coach.goal.coldConditions.adj3.effect': 'Genereert meer mechanische grip',
  'coach.goal.coldConditions.adj3.side': 'Kan gaan stuiteren op een natte baan',
  'coach.goal.coldConditions.adj4.param': 'Spoorbreedte voor & achter',
  'coach.goal.coldConditions.adj4.change': 'Beide verbreden',
  'coach.goal.coldConditions.adj4.effect': 'Maximaliseert mechanische grip',
  'coach.goal.coldConditions.adj4.side': 'Agressiever rijgedrag',
  'coach.goal.coldConditions.adj5.param': 'Luchtschroef',
  'coach.goal.coldConditions.adj5.change': 'Sluiten (minder slagen uit)',
  'coach.goal.coldConditions.adj5.effect': 'Armer stationair mengsel',
  'coach.goal.coldConditions.adj5.side': 'Kan koude start beïnvloeden',

  // Braking Stability
  'coach.goal.braking.title': 'Remstabiliteit verbeteren',
  'coach.goal.braking.desc': 'De kart is instabiel tijdens het aanremmen, waarbij de achterkant uitbreekt of de voorwielen blokkeren. Dit maakt het lastig om laat en consistent te remmen, wat tijd kost bij het ingaan van de bocht.',
  'coach.goal.braking.adj1.param': 'Bandenspanning voor',
  'coach.goal.braking.adj1.change': 'Verhogen',
  'coach.goal.braking.adj1.effect': 'Preciezere voorkant tijdens het remmen',
  'coach.goal.braking.adj1.side': 'Kleiner remcontactoppervlak',
  'coach.goal.braking.adj2.param': 'Caster voor',
  'coach.goal.braking.adj2.change': 'Vergroten',
  'coach.goal.braking.adj2.effect': 'Meer naloop, stabiliseert onder het remmen',
  'coach.goal.braking.adj2.side': 'Zwaarder sturen',
  'coach.goal.braking.adj3.param': 'Rijhoogte voor',
  'coach.goal.braking.adj3.change': 'Verlagen',
  'coach.goal.braking.adj3.effect': 'Meer gewichtsverplaatsing naar voren',
  'coach.goal.braking.adj3.side': 'Risico op raken van het asfalt',
  'coach.goal.braking.adj4.param': 'Torsiestang voor',
  'coach.goal.braking.adj4.change': 'Toevoegen',
  'coach.goal.braking.adj4.effect': 'Maakt de voorkant stijver tijdens het remmen',
  'coach.goal.braking.adj4.side': 'Kan grip bij het insturen verminderen',
  'coach.goal.braking.adj5.param': 'Bandenspanning achter',
  'coach.goal.braking.adj5.change': 'Verlagen',
  'coach.goal.braking.adj5.effect': 'Voorkomt blokkeren van de achteras',
  'coach.goal.braking.adj5.side': 'Tragere respons van de achterkant',

  // Engine Tuning
  'coach.goal.engine.title': 'Motorprestaties fijnstellen',
  'coach.goal.engine.desc': 'Optimaliseer het motorvermogen via tandwielverhoudingen en carburateurafstellingen. Deze aanpassingen beïnvloeden de vermogensafgifte, acceleratie, topsnelheid en motorveiligheid. Controleer altijd de uitlaatgastemperatuur (EGT) bij het aanpassen van de sproeierbezetting.',
  'coach.goal.engine.adj1.param': 'Achtertandwiel',
  'coach.goal.engine.adj1.change': 'Vergroten (meer tanden)',
  'coach.goal.engine.adj1.effect': 'Meer acceleratie, lagere topsnelheid',
  'coach.goal.engine.adj1.side': 'Hoger toerental (RPM) op rechte stukken',
  'coach.goal.engine.adj2.param': 'Achtertandwiel',
  'coach.goal.engine.adj2.change': 'Verkleinen (minder tanden)',
  'coach.goal.engine.adj2.effect': 'Hogere topsnelheid, minder acceleratie',
  'coach.goal.engine.adj2.side': 'Lager toerental, trager uitkomen van bochten',
  'coach.goal.engine.adj3.param': 'Hoofdsproeier',
  'coach.goal.engine.adj3.change': 'Rijker zetten (groter nummer)',
  'coach.goal.engine.adj3.effect': 'Lagere EGT, veiliger voor de motor',
  'coach.goal.engine.adj3.side': 'Licht vermogensverlies',
  'coach.goal.engine.adj4.param': 'Hoofdsproeier',
  'coach.goal.engine.adj4.change': 'Armer zetten (kleiner nummer)',
  'coach.goal.engine.adj4.effect': 'Meer vermogen',
  'coach.goal.engine.adj4.side': 'Risico op vastloper, hogere EGT',
  'coach.goal.engine.adj5.param': 'Gasnaaldclip',
  'coach.goal.engine.adj5.change': 'Clip hoger plaatsen',
  'coach.goal.engine.adj5.effect': 'Armer middengebied, meer vermogen',
  'coach.goal.engine.adj5.side': 'Risico op een te arm mengsel',
  'coach.goal.engine.adj6.param': 'Vlotterhoogte',
  'coach.goal.engine.adj6.change': 'Aanpassen',
  'coach.goal.engine.adj6.effect': 'Regelt het brandstofniveau in de vlotterkamer',
  'coach.goal.engine.adj6.side': 'Beïnvloedt alle toerentalgebieden',

  // Track Map Controls
  'trackMap.zoomIn': 'Inzoomen',
  'trackMap.zoomOut': 'Uitzoomen',
  'trackMap.fitTrack': 'Circuit passend maken',
  'trackMap.satellite': 'Satelliet',
  'trackMap.vector': 'Vector',
  'trackMap.switchProvider': 'Luchtfoto-aanbieder wisselen',

  // Lap Analysis Queue & Amended Analysis
  'queue.processingLaps': 'Ronden analyseren {done}/{total}',
  'queue.completed': 'Rondeanalyse voltooid ({total}/{total})',
  'tracks.reanalyzeLaps': 'Ronden opnieuw analyseren',
  'tracks.reanalyzingLaps': 'In wachtrij plaatsen…',
  'tracks.reanalyzeQueued': '{enqueued} ronde(n) in de wachtrij geplaatst voor analyse ({skipped} al up-to-date).',
  'tracks.reanalyzeAllUpToDate': 'Alle {skipped} ronde(n) zijn al up-to-date met de huidige circuitgegevens.',
  'lapInfo.canonicalSectors': 'Circuitsectoren',
  'lapInfo.loggerSectors': 'Loggersectoren',
  'lapAnalysis.amendedCornersTitle': 'Bocht- & remanalyse',
  'lapAnalysis.cornerCol': 'Bocht',
  'lapAnalysis.topApproachSpeed': 'Topsnelheid vóór het remmen',
  'lapAnalysis.slowestSpeed': 'Laagste snelheid',
  'lapAnalysis.apexSpeed': 'Apexsnelheid',
  'lapAnalysis.exitSpeed': 'Uitsnelheid',
  'lapAnalysis.brakingDist': 'Remafst.',
  'lapAnalysis.cornerTime': 'Duur',
  'lapAnalysis.statusCompleted': 'Analyse voltooid',
  'lapAnalysis.statusPending': 'Analyse in afwachting',
  'session.tabCorners': 'Bochten',
  'session.noCornersConfigured': 'Geen bochtanalysegegevens beschikbaar voor deze sessie.',
  'lapAnalysis.entrySpeed': 'Ingangssnelheid',
  'lapAnalysis.trailBraking': 'Trailbraking',

  // Terms & Conditions
  'footer.termsAndConditions': 'Algemene Voorwaarden',
  'terms.gateTitle': 'Algemene Voorwaarden',
  'terms.gateSubtitle': 'Bekijk en accepteer de nieuwste Algemene Voorwaarden om door te gaan.',
  'terms.updatedBannerTitle': 'Bijgewerkte Algemene Voorwaarden:',
  'terms.updatedBannerDesc': 'Onze Algemene Voorwaarden zijn bijgewerkt. Bekijk en accepteer de nieuwe versie om kart.win te blijven gebruiken.',
  'terms.checkboxLabel': 'Ik heb de Algemene Voorwaarden gelezen en ga hiermee akkoord',
  'terms.acceptButton': 'Accepteren & doorgaan',
  'terms.acceptingButton': 'Accepteren…',
  'terms.loadError': 'Kan de Algemene Voorwaarden niet laden. Controleer je verbinding en probeer het opnieuw.',
  'terms.acceptError': 'Het registreren van je acceptatie is mislukt. Probeer het opnieuw.',

  // Additional Common & Import Keys
  'common.previous': 'Vorige',
  'common.remove': 'Verwijderen',
  'common.success': 'Succesvol opgeslagen',
  'common.failedToSave': 'Opslaan mislukt',
  'import.useCurrentSetupDesc': 'Koppel de huidige actieve kart-setup aan de geïmporteerde sessie(s).',

  // Search & Filter Bar
  'search.booleanLogicUse': 'Combineer termen met',
  'search.booleanLogicOr': 'of',
  'search.booleanLogicGroup': 'en groepeer expressies met haakjes',
  'filter.operator.eq': 'is',
  'filter.operator.neq': 'is niet',
  'filter.operator.gt': 'groter dan',
  'filter.operator.gte': 'minstens',
  'filter.operator.lt': 'kleiner dan',
  'filter.operator.lte': 'hoogstens',
  'filter.operator.range': 'tussen',
  'filter.operator.contains': 'bevat',
  'filter.remove': 'Filter verwijderen',
  'filter.done': 'Klaar',
  'filter.clearInput': 'Invoer wissen',
  'filter.selectField': 'Filteren op veld',
  'filter.pressEnter': 'Druk op Enter om toe te passen',
  'filter.selectValues': 'Waarden selecteren',
  'filter.noMatchingOptions': 'Geen overeenkomende opties',

  // Search Schemas
  'filter.session.bareSearchExample': 'Zoeken op circuitnaam',
  'filter.session.searchTrack': 'Filteren op circuitnaam',
  'filter.session.filterLaps': 'Filteren op totaal aantal ronden',
  'filter.session.filterBestTime': 'Filteren op beste rondetijd (seconden)',
  'filter.session.filterMaxSpeed': 'Filteren op topsnelheid (km/u)',
  'filter.session.filterMaxRpm': 'Filteren op maximaal toerental',
  'filter.session.filterDate': 'Filteren op sessiedatum',
  'filter.session.filterShared': 'Filteren op teamdeelstatus',
  'filter.session.filterVisibility': 'Filteren op eigendom of teamzichtbaarheid',
  'filter.session.visibilityMine': 'Mijn sessies',
  'filter.session.visibilityShared': 'Gedeeld met team',
  'filter.session.exampleTrackLaps': 'Sessies op Lonato met 10+ ronden',
  'filter.session.exampleBestSpeed': 'Snelle ronden met hoge topsnelheid',

  'filter.analysis.bareSearchExample': 'Zoeken op analysetitel of circuitnaam',
  'filter.analysis.searchTitle': 'Filteren op analysetitel',
  'filter.analysis.searchTrack': 'Filteren op circuitnaam',
  'filter.analysis.filterType': 'Filteren op analysetype',
  'filter.analysis.filterDate': 'Filteren op aanmaakdatum',
  'filter.analysis.filterShared': 'Filteren op teamdeelstatus',
  'filter.analysis.filterVisibility': 'Filteren op eigendom of teamdeling',
  'filter.analysis.exampleCornerTrack': 'Bochtanalyses op Lonato',
  'filter.analysis.exampleSharedDate': 'Gedeelde analyses uit 2026',

  'filter.trackRaces.bareSearchExample': 'Zoeken op evenementnaam, seizoen of categorie',
  'filter.trackRaces.searchTitle': 'Filteren op evenementnaam',
  'filter.trackRaces.searchSeason': 'Filteren op kampioenschapsseizoen',
  'filter.trackRaces.searchCategory': 'Filteren op racecategorie',
  'filter.trackRaces.filterRound': 'Filteren op rondenummer',
  'filter.trackRaces.filterDate': 'Filteren op evenementdatum',
  'filter.trackRaces.exampleCatDate': 'ROK Mini-evenementen in 2026',
  'filter.trackRaces.exampleSeasonRound': 'Eerste twee ronden van de ROK Cup',

  'filter.tracks.bareSearchExample': 'Zoeken op circuitnaam of land',
  'filter.tracks.searchName': 'Filteren op circuitnaam',
  'filter.tracks.searchCountry': 'Filteren op landcode',
  'filter.tracks.filterType': 'Filteren op circuitbron (officieel of gemeten)',
  'filter.tracks.filterSessions': 'Filteren op aantal geregistreerde sessies',
  'filter.tracks.filterLaps': 'Filteren op aantal geregistreerde ronden',
  'filter.tracks.filterEvents': 'Filteren op aantal officiële race-evenementen',
  'filter.tracks.filterDrivers': 'Filteren op aantal officiële rijders',
  'filter.tracks.exampleItSessions': 'Italiaanse circuits met geregistreerde sessies',
  'filter.tracks.exampleOfficialEvents': 'Officiële circuits met 3+ evenementen',

  'filter.leaderboard.bareSearchExample': 'Zoeken op rijder, categorie, seizoen of evenement',
  'filter.leaderboard.searchDriver': 'Filteren op rijdersnaam',
  'filter.leaderboard.searchCategory': 'Filteren op racecategorie',
  'filter.leaderboard.searchSeason': 'Filteren op kampioenschapsseizoen',
  'filter.leaderboard.searchEvent': 'Filteren op evenementnaam',
  'filter.leaderboard.filterLapTime': 'Filteren op rondetijd (seconden)',
  'filter.leaderboard.filterSpeed': 'Filteren op topsnelheid (km/u)',
  'filter.leaderboard.filterRpm': 'Filteren op maximaal toerental',
  'filter.leaderboard.filterDate': 'Filteren op rondedatum',
  'filter.leaderboard.exampleTimeSpeed': 'Ronden onder 48s met hoge topsnelheid',
  'filter.leaderboard.exampleCatTime': 'Mini-ronden tussen 52s en 54s',

  'filter.tyres.bareSearchExample': 'Zoeken op bandennaam, merk, model of barcode',
  'filter.tyres.searchName': 'Filteren op naam van bandenset',
  'filter.tyres.searchBrand': 'Filteren op bandenmerk',
  'filter.tyres.searchModel': 'Filteren op bandencompound/-model',
  'filter.tyres.searchSize': 'Filteren op bandenmaat',
  'filter.tyres.searchBarcode': 'Filteren op gescande barcode',
  'filter.tyres.filterStatus': 'Filteren op levenscyclusstatus',
  'filter.tyres.filterCondition': 'Filteren op resterende conditie (%)',
  'filter.tyres.filterLaps': 'Filteren op totaal gereden ronden',
  'filter.tyres.filterDistance': 'Filteren op totaal gereden afstand (km)',
  'filter.tyres.exampleActiveBrand': 'Actieve LeCont-bandensets',
  'filter.tyres.exampleConditionLaps': 'Banden met >50% levensduur en <30 ronden',

  'filter.teamMembers.bareSearchExample': 'Zoeken op naam of e-mail van teamlid',
  'filter.teamMembers.searchName': 'Filteren op naam van teamlid',
  'filter.teamMembers.searchEmail': 'Filteren op e-mail van teamlid',
  'filter.teamMembers.filterRole': 'Filteren op teamrol',
  'filter.teamMembers.exampleRoleAdmin': 'Teambeheerders',
  'filter.teamMembers.exampleNameRole': 'Teamleden of editors op naam',

  'filter.teamSharing.bareSearchExample': 'Zoeken op titel, eigenaar of circuit',
  'filter.teamSharing.searchTitle': 'Filteren op itemtitel',
  'filter.teamSharing.searchOwner': 'Filteren op naam van eigenaar',
  'filter.teamSharing.searchTrack': 'Filteren op circuitnaam',
  'filter.teamSharing.filterKind': 'Filteren op type gedeeld item',
  'filter.teamSharing.kindSession': 'Sessie',
  'filter.teamSharing.kindAnalysis': 'Analyse',
  'filter.teamSharing.filterAccess': 'Filteren op toegangsrechten',
  'filter.teamSharing.accessRead': 'Alleen lezen',
  'filter.teamSharing.accessWrite': 'Lezen & schrijven',
  'filter.teamSharing.exampleSessionTrack': 'Gedeelde sessies van Lonato',
  'filter.teamSharing.exampleAnalysisWrite': 'Bewerkbare gedeelde analyses',

  'filter.drivers.bareSearchExample': 'Zoeken op rijdersnaam, team, categorie of materiaal',
  'filter.drivers.searchName': 'Filteren op rijdersnaam',
  'filter.drivers.searchCountry': 'Filteren op nationaliteitscode',
  'filter.drivers.searchTeam': 'Filteren op raceteam',
  'filter.drivers.searchCategory': 'Filteren op racecategorie',
  'filter.drivers.searchChassis': 'Filteren op chassismerk',
  'filter.drivers.searchEngine': 'Filteren op motormerk',
  'filter.drivers.filterEntries': 'Filteren op aantal deelnames',
  'filter.drivers.exampleCountryEntries': 'Italiaanse rijders met 5+ deelnames',
  'filter.drivers.exampleCatTeam': 'Mini-rijders van een specifiek team',

  'filter.driverHistory.bareSearchExample': 'Zoeken op seizoen, evenement, circuit of categorie',
  'filter.driverHistory.searchSeason': 'Filteren op kampioenschapsseizoen',
  'filter.driverHistory.searchEvent': 'Filteren op evenementnaam',
  'filter.driverHistory.searchTrack': 'Filteren op circuitnaam',
  'filter.driverHistory.searchCategory': 'Filteren op categorie',
  'filter.driverHistory.searchTeam': 'Filteren op teamnaam',
  'filter.driverHistory.filterPos': 'Filteren op eindpositie',
  'filter.driverHistory.filterGrid': 'Filteren op startpositie',
  'filter.driverHistory.filterPoints': 'Filteren op behaalde punten',
  'filter.driverHistory.filterBestLap': 'Filteren op snelste rondetijd (seconden)',
  'filter.driverHistory.filterPenalties': 'Filteren op aantal straffen',
  'filter.driverHistory.examplePodiums': 'Podiumplaatsen (Top 3)',
  'filter.driverHistory.examplePointsPenalty': 'Evenementen met veel punten zonder straffen',

  // Additional Analysis & Component Keys
  'braking.colSelect': 'Sel',
  'braking.colCompare': 'Vgl',
  'braking.scoreUnit': '/ 100',
  'braking.trackOverview': 'Circuitoverzicht',
  'braking.cornersCount': '{count} bochten',
  'braking.trackAnalysis': 'Remanalyse op het circuit',
  'braking.lapsTotal': '{count} ronden totaal',
  'braking.sample': 'Monster',
  'lapdiff.pointDetail': 'Puntdetails',
  'lapdiff.selectTwoLaps': 'Selecteer 2 ronden',
  'lapdiff.lapTime': 'Rondetijd',
  'aggregationdiff.toggleLayers': 'Kaartlagen schakelen',
  'aggregationdiff.leftInner': 'Links (Binnen)',
  'aggregationdiff.rightOuter': 'Rechts (Buiten)',
  'aggregationdiff.selectLap': 'Selecteer een ronde',
  'aggregationdiff.modeSingleLap': 'Enkele ronde',
  'aggregationdiff.modeSessions': 'Sessies',
  'braking.phaseBraking': 'Remmen',
  'braking.phaseAccel': 'Acceleratie',
  'setup.tabFront': 'Voor',
  'setup.tabRear': 'Achter',
  'team.you': 'Jij',
  'races.entries': 'Deelnemers',
  // Filter Schema & UI Translations
  'filter.filterBy': 'Filteren op {label}',
  'filter.removeFilter': 'Filter {label} verwijderen',
  'filter.prevMonth': 'Vorige maand',
  'filter.nextMonth': 'Volgende maand',
  'filter.selectStartDate': 'Selecteer startdatum in kalender',
  'filter.op.exact': 'Exact',
  'filter.op.atLeast': 'Minstens',
  'filter.op.atMost': 'Hoogstens',
  'filter.op.between': 'Tussen',
  'filter.op.greater': 'Groter',
  'filter.op.less': 'Kleiner',
  'filter.preset.today': 'Vandaag',
  'filter.preset.last7d': 'Laatste 7 dagen',
  'filter.preset.last30d': 'Laatste 30 dagen',
  'filter.preset.last90d': 'Laatste 90 dagen',
  'filter.preset.last1y': 'Afgelopen jaar',
  'filter.preset.last7dShort': 'Laatste 7d',
  'filter.preset.last30dShort': 'Laatste 30d',
  'filter.preset.last90dShort': 'Laatste 90d',
  'filter.preset.last1yShort': 'Laatste 1j',
  'filter.sessionType.race': 'Race',
  'filter.sessionType.final': 'Finale',
  'filter.sessionType.pre_final': 'Pre-finale',
  'filter.sessionType.heat': 'Heat',
  'filter.sessionType.qualifying': 'Kwalificatie',
  'filter.unit.laps': 'ronden',
  'filter.schema.tyres.title': 'Banden-zoeksyntax',
  'filter.schema.tyres.subtitle': 'Banden filteren op merk, compound, gebruik, barcode, circuit of afgevoerde status.',
  'filter.field.brand': 'Merk',
  'filter.desc.brand': 'Bandenfabrikant (Mojo, Vega, LeCont, Bridgestone, enz.)',
  'filter.field.tyreModel': 'Bandenmodel',
  'filter.placeholder.tyreModel': 'bijv. D2, D5, W5, CIK Option',
  'filter.desc.tyreModel': 'Modelnaam of compoundspecificatie',
  'filter.field.compound': 'Compound',
  'filter.desc.compound': 'Bandencompoundcategorie (droog, nat, slick, regen)',
  'filter.compound.dry': 'Droog',
  'filter.compound.wet': 'Nat',
  'filter.compound.slick': 'Slick',
  'filter.compound.rain': 'Regen',
  'filter.field.setNumber': 'Setnummer',
  'filter.desc.setNumber': 'Bandensetnummer toegewezen in inventaris',
  'filter.field.totalLaps': 'Totaal aantal ronden',
  'filter.desc.totalLaps': 'Cumulatief totaal aantal ronden gereden op deze bandenset',
  'filter.preset.tyreFresh': 'Nieuw (0..15 ronden)',
  'filter.preset.tyreBrokenIn': 'Ingereden (16..50 ronden)',
  'filter.preset.tyreHighMileage': 'Hoge kilometerstand (> 50 ronden)',
  'filter.field.barcode': 'Barcode',
  'filter.placeholder.barcode': 'LV-, RV-, LA-, RA-barcode',
  'filter.desc.barcode': 'Gedeeltelijke overeenkomst op een bandenbarcode binnen de set',
  'filter.field.lastTrack': 'Laatste circuit',
  'filter.desc.lastTrack': 'Laatste circuit waar deze bandenset is gebruikt',
  'filter.field.discarded': 'Afgevoerd',
  'filter.desc.discarded': 'Of de bandenset als afgevoerd is gemarkeerd',
  'filter.discarded.false': 'Nee',
  'filter.discarded.true': 'Ja',
  'filter.example.activeTyres': 'Actieve (niet-afgevoerde) bandensets',
  'filter.example.dryMojo': 'Droogweerbanden van Mojo',
  'filter.example.highMileage70': 'Bandensets met meer dan 70 ronden',
  'filter.example.freshTyres': 'Nieuwe banden / lage kilometerstand',
  'filter.example.lonatoTyres': 'Banden gebruikt in Lonato sinds augustus 2026',
  'filter.example.vegaOrWet': 'Vega-sets of regenbanden',
  'filter.field.date': 'Datum',
  'filter.desc.date': 'Filteren op relatieve periode (-7d, -30d, today) of datumbereik',
  'filter.field.track': 'Circuit',
  'filter.desc.track': 'Komt overeen met circuitnaam',
  'filter.placeholder.track': 'bijv. Wohlen, Lonato',
  'filter.field.driver': 'Rijder',
  'filter.desc.driver': 'Komt overeen met de naam van de rijder',
  'filter.placeholder.driver': 'bijv. Yanick',
  'filter.field.season': 'Seizoen',
  'filter.desc.season': 'Komt overeen met het seizoensjaar',
  'filter.field.category': 'Categorie',
  'filter.desc.category': 'Canonieke racecategorie',
  'filter.field.championship': 'Kampioenschap',
  'filter.desc.championship': 'Naam van het kampioenschap',
  'filter.field.sessionType': 'Sessietype',
  'filter.desc.sessionType': 'Sessieclassificatie (race, heat, kwalificatie, finale)',
  'filter.field.position': 'Positie',
  'filter.field.finishPosition': 'Eindpositie',
  'filter.desc.position': 'Eindpositie (bijv. position:<=3 voor podiumplaatsen)',
  'filter.preset.posWinner': 'Winnaar (P1)',
  'filter.preset.posPodium': 'Podium (≤ P3)',
  'filter.preset.posTop5': 'Top 5 (≤ P5)',
  'filter.preset.posTop10': 'Top 10 (≤ P10)',
  'filter.field.temp': 'Temperatuur',
  'filter.desc.temp': 'Omgevingstemperatuur van de sessie in Celsius (bijv. temp:15..25)',
  'filter.preset.tempCool': 'Koel (< 15°C)',
  'filter.preset.tempMild': 'Mild (15..25°C)',
  'filter.preset.tempWarm': 'Warm (≥ 25°C)',
  'filter.field.laps': 'Ronden',
  'filter.desc.laps': 'Komt overeen met het aantal voltooide ronden (bijv. laps:>=5, laps:5..20)',
  'filter.preset.lapsShort': 'Kort (≤ 5 ronden)',
  'filter.preset.lapsMedium': 'Gemiddeld (6..15 ronden)',
  'filter.preset.lapsLong': 'Lang (> 15 ronden)',
  'analysis.sector': 'Sectoranalyse',
  'analysis.corner': 'Bochtsnelheid',
  'analysis.braking': 'Remanalyse',
  'analysis.lapdiff': 'Rondevergelijking',
  'analysis.aggregation': 'Aggregatie',
  'analysis.aggregationdiff': 'Aggregatievergelijking',
  'filter.schema.analyses.title': 'Analyse-zoeksyntax',
  'filter.schema.analyses.subtitle': 'Analysegeschiedenis filteren met gestructureerde sleutels of trefwoorden.',
  'filter.field.nameTrack': 'Naam / Circuit',
  'filter.placeholder.nameTrack': 'bijv. Sarno, Eigen sessie',
  'filter.desc.nameTrack': 'Komt overeen met analysenaam of circuitnaam (gedeeltelijke overeenkomst)',
  'filter.field.toolType': 'Analysetype',
  'filter.placeholder.toolType': 'bijv. sector, corner, lapdiff, aggregation, aggregationdiff',
  'filter.desc.toolType': 'Filteren op analysetool (sector, corner, lapdiff, aggregation, aggregationdiff)',
  'filter.example.sarnoSector': 'Sectoranalyses op Sarno',
  'filter.example.lapdiff30d': 'Rondevergelijkingen van de laatste 30 dagen',
  'filter.example.wohlenCorner': 'Bochtanalyses op Wohlen of Mirecourt',
  'filter.schema.sessions.title': 'Sessie-zoeksyntax',
  'filter.schema.sessions.subtitle': 'Sessies filteren met gestructureerde sleutels of trefwoorden.',
  'filter.field.trackDriver': 'Circuit / Rijder',
  'filter.placeholder.trackDriver': 'bijv. Wohlen, Mirecourt',
  'filter.desc.trackDriver': 'Komt overeen met circuitnaam of rijdersnaam (gedeeltelijke overeenkomst)',
  'filter.schema.driverHistory.title': 'Rijdersgeschiedenis-zoeksyntax',
  'filter.schema.driverHistory.subtitle': 'Carrière-racegeschiedenis filteren op circuit, kampioenschap, categorie, sessietype, positie of seizoen.',
  'filter.example.podiumWohlen': 'Podiumplaatsen in Wohlen',
  'filter.example.dd2Races2026': 'DD2-races in 2026',
  'filter.example.victoriesLast1y': 'Overwinningen in het afgelopen jaar',
  'filter.schema.driversList.title': 'Rijders-zoeksyntax',
  'filter.schema.driversList.subtitle': 'Rijders filteren op naam, actief seizoen, categorie of deelnamedatum.',
  'filter.field.driverName': 'Naam rijder',
  'filter.placeholder.driverName': 'bijv. Yanick, Senn',
  'filter.desc.driverName': 'Komt overeen met voor- of achternaam van de rijder',
  'filter.example.findDriverYanick': 'Zoek rijders die overeenkomen met Yanick',
  'filter.example.activeDd22026': 'Actieve DD2-rijders in 2026',
  'filter.example.driversLast90d': 'Rijders die in de afgelopen 90 dagen hebben geracet',
  'filter.schema.teamMembers.title': 'Teamleden-zoeksyntax',
  'filter.schema.teamMembers.subtitle': 'Teamleden filteren op naam, rol of e-mail.',
  'filter.field.memberName': 'Naam teamlid',
  'filter.placeholder.memberName': 'bijv. Yanick, Alice',
  'filter.desc.memberName': 'Komt overeen met de weergavenaam van het lid',
  'filter.field.role': 'Rol',
  'filter.desc.role': 'Toegangsniveau (beheerder, beheren, lezen)',
  'team.role.admin': 'Beheerder',
  'filter.field.email': 'E-mail',
  'filter.placeholder.email': 'bijv. gmail.com',
  'filter.desc.email': 'Komt overeen met het e-mailadres',
  'filter.example.findMemberYanick': 'Zoek leden die overeenkomen met Yanick',
  'filter.example.findTeamAdmins': 'Teambeheerders zoeken',
  'filter.example.findTeamManage': 'Leden met beheerrechten zoeken',
  'filter.schema.teamSharing.title': 'Teamdeling-zoeksyntax',
  'filter.schema.teamSharing.subtitle': 'Gedeelde toegang filteren op eigenaar, deeltype of toestemmingsniveau.',
  'filter.field.ownerName': 'Eigenaar / Naam',
  'filter.desc.ownerName': 'Komt overeen met de naam van de eigenaar',
  'filter.field.shareScope': 'Deelbereik',
  'filter.desc.shareScope': 'Type deelbereik (alle gegevens, enkele sessie, specifiek circuit)',
  'filter.shareScope.all': 'Alle telemetrie',
  'filter.shareScope.single': 'Enkele sessie',
  'filter.shareScope.track': 'Specifiek circuit',
  'filter.example.sharesYanick': 'Gedeelde items van Yanick zoeken',
  'filter.example.sharesAllRead': 'Alleen-lezen volledige telemetriedelingen',
  'filter.schema.trackLeaderboard.title': 'Circuit-ranglijst-zoeksyntax',
  'filter.schema.trackLeaderboard.subtitle': 'Ronden en sessies op de ranglijst filteren op rijder, seizoen, categorie, positie of temperatuur.',
  'filter.example.yanickFastest2026': 'Snelste ronden van Yanick in het seizoen 2026',
  'filter.example.podiumSeniorMax': 'Podiumplaatsen in Senior MAX',
  'filter.example.warm90d': 'Sessies bij warm weer in de afgelopen 90 dagen',
  'filter.schema.trackRaceEvents.title': 'Race-evenementen-zoeksyntax',
  'filter.schema.trackRaceEvents.subtitle': 'Race-evenementen filteren op seizoen, kampioenschap, categorie of deelnemende rijder.',
  'filter.desc.driverEvent': 'Komt overeen met een rijder die deelneemt aan het evenement',
  'filter.example.rmc2026': 'RMC Switzerland-evenementen 2026',
  'filter.example.yanick2025': 'Evenementen waaraan Yanick deelnam in 2025',
  'filter.example.dd2Last1y': 'DD2-evenementen in het afgelopen jaar',
  'filter.schema.tracks.title': 'Circuit-zoeksyntax',
  'filter.schema.tracks.subtitle': 'Circuits filteren op naam of trefwoorden.',
  'filter.field.trackName': 'Circuitnaam',
  'filter.example.findWohlen': 'Circuits zoeken die overeenkomen met Wohlen',
  'filter.example.exactTrack': 'Exacte overeenkomst op circuitnaam',
};
